/* HP Cart Upsell v2.0 — aceite de ofertas + cupom no cart drawer.
   Princípios: (1) nunca calcula desconto — o markup volta server-rendered com o carrinho real;
   (2) camada aditiva — qualquer erro degrada para o drawer padrão;
   (3) listeners delegados no document — sobrevivem aos re-renders (innerHTML swap).
   Debug: acrescente ?hp_debug=1 à URL para logs no console. */
(function () {
  'use strict';

  var DEBUG = /[?&]hp_debug=1/.test(window.location.search);
  var hpTrace = [];
  function trace(event, detail) {
    if (!DEBUG) return;
    hpTrace.push({ at: new Date().toISOString(), event: event, detail: detail || null });
    if (hpTrace.length > 80) hpTrace.shift();
    window.__hpCartTrace = hpTrace.slice();
  }
  function log() {
    if (DEBUG && window.console) {
      var args = [].slice.call(arguments);
      trace(args[0], args.slice(1));
      console.log.apply(console, ['[hp-upsell]'].concat(args));
    }
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Um re-render completo do Sense recria o conteúdo do drawer e zera scroll,
     details e foco. A referência pendente nasce ANTES da mutação para também
     sobreviver ao primeiro paint nativo, não apenas ao swap executado por nós. */
  var hpPendingDrawerView = null;
  var hpDrawerViewTimer = null;
  var hpRestoringDrawerView = false;

  function hpDrawerRowIdentity(row) {
    if (!row) return null;
    var allRows = [].slice.call(document.querySelectorAll('cart-drawer .cart-item'));
    var variant = row.getAttribute('data-hp-variant-id') || '';
    var rule = row.getAttribute('data-hp-offer-rule') || '';
    var link = row.querySelector('.cart-item__name');
    var href = link ? (link.getAttribute('href') || '').split('?')[0] : '';
    var occurrence = 0;
    for (var i = 0; i < allRows.length; i++) {
      if (allRows[i] === row) break;
      var otherLink = allRows[i].querySelector('.cart-item__name');
      var otherHref = otherLink ? (otherLink.getAttribute('href') || '').split('?')[0] : '';
      if ((allRows[i].getAttribute('data-hp-variant-id') || '') === variant &&
        (allRows[i].getAttribute('data-hp-offer-rule') || '') === rule && otherHref === href) occurrence++;
    }
    return {
      key: row.getAttribute('data-hp-line-key') || '',
      variant: variant,
      rule: rule,
      href: href,
      occurrence: occurrence
    };
  }

  function hpFindDrawerRow(identity) {
    if (!identity) return null;
    var rows = [].slice.call(document.querySelectorAll('cart-drawer .cart-item'));
    for (var i = 0; identity.key && i < rows.length; i++) {
      if (rows[i].getAttribute('data-hp-line-key') === identity.key) return rows[i];
    }
    var occurrence = 0;
    for (var j = 0; j < rows.length; j++) {
      var link = rows[j].querySelector('.cart-item__name');
      var href = link ? (link.getAttribute('href') || '').split('?')[0] : '';
      if ((rows[j].getAttribute('data-hp-variant-id') || '') !== identity.variant ||
        (rows[j].getAttribute('data-hp-offer-rule') || '') !== identity.rule || href !== identity.href) continue;
      if (occurrence === identity.occurrence) return rows[j];
      occurrence++;
    }
    return null;
  }

  function hpCaptureDrawerView() {
    var host = document.querySelector('cart-drawer');
    var inner = host && host.querySelector('.drawer__inner');
    var scroller = inner && inner.querySelector('cart-drawer-items');
    if (!host || !inner || !scroller || !host.classList.contains('active')) return null;
    var state = {
      at: Date.now(),
      scrollTop: scroller.scrollTop,
      remaining: Math.max(0, scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop),
      openCoupon: !!inner.querySelector('[data-hp-coupon-details][open]'),
      openNote: !!inner.querySelector('#Details-CartDrawer[open]'),
      anchorType: '',
      anchorOffset: 0,
      anchorRow: null,
      focusType: '',
      focusValue: '',
      focusRow: null
    };
    var scrollerRect = scroller.getBoundingClientRect();
    var anchors = [].slice.call(scroller.querySelectorAll('.cart-item, .hp-offers, .hp-drawer-extras'));
    for (var i = 0; i < anchors.length; i++) {
      var rect = anchors[i].getBoundingClientRect();
      if (rect.bottom <= scrollerRect.top + 4) continue;
      state.anchorOffset = rect.top - scrollerRect.top;
      if (anchors[i].classList.contains('cart-item')) {
        state.anchorType = 'row';
        state.anchorRow = hpDrawerRowIdentity(anchors[i]);
      } else if (anchors[i].classList.contains('hp-offers')) {
        state.anchorType = 'offers';
      } else {
        state.anchorType = 'extras';
      }
      break;
    }
    var active = document.activeElement;
    if (active && inner.contains(active)) {
      var focusRow = active.closest('.cart-item');
      if (active.matches('[data-hp-coupon-input]')) {
        state.focusType = 'coupon-input';
      } else if (active.matches('[data-hp-coupon-submit]')) {
        state.focusType = 'coupon-submit';
      } else if (active.matches('[data-hp-coupon-remove]')) {
        state.focusType = 'coupon-remove';
        state.focusValue = active.getAttribute('data-hp-coupon-remove') || '';
      } else if (active.getAttribute('name') && focusRow) {
        state.focusType = 'row-name';
        state.focusValue = active.getAttribute('name');
        state.focusRow = hpDrawerRowIdentity(focusRow);
      }
    }
    return state;
  }

  function hpRestoreDrawerView(state, restoreFocus) {
    if (!state || Date.now() - state.at > 15000) return;
    var host = document.querySelector('cart-drawer');
    var inner = host && host.querySelector('.drawer__inner');
    var scroller = inner && inner.querySelector('cart-drawer-items');
    if (!host || !inner || !scroller || !host.classList.contains('active')) return;
    var coupon = inner.querySelector('[data-hp-coupon-details]');
    var note = inner.querySelector('#Details-CartDrawer');
    if (coupon) coupon.open = state.openCoupon;
    if (note) note.open = state.openNote;

    var anchor = null;
    if (state.anchorType === 'row') anchor = hpFindDrawerRow(state.anchorRow);
    else if (state.anchorType === 'offers') anchor = scroller.querySelector('.hp-offers');
    else if (state.anchorType === 'extras') anchor = scroller.querySelector('.hp-drawer-extras');
    var target = state.scrollTop;
    if (anchor) {
      target = scroller.scrollTop + anchor.getBoundingClientRect().top - scroller.getBoundingClientRect().top - state.anchorOffset;
    } else if (state.remaining < 24) {
      target = scroller.scrollHeight - scroller.clientHeight;
    }
    target = Math.max(0, Math.min(target, scroller.scrollHeight - scroller.clientHeight));
    hpRestoringDrawerView = true;
    scroller.scrollTop = target;

    if (restoreFocus && state.focusType) {
      var focus = null;
      if (state.focusType === 'coupon-input') focus = inner.querySelector('[data-hp-coupon-input]');
      else if (state.focusType === 'coupon-submit') focus = inner.querySelector('[data-hp-coupon-submit]');
      else if (state.focusType === 'coupon-remove') {
        var removes = inner.querySelectorAll('[data-hp-coupon-remove]');
        for (var i = 0; i < removes.length; i++) {
          if (removes[i].getAttribute('data-hp-coupon-remove') === state.focusValue) { focus = removes[i]; break; }
        }
      } else if (state.focusType === 'row-name') {
        var row = hpFindDrawerRow(state.focusRow);
        var named = row && row.querySelectorAll('[name]');
        for (var j = 0; named && j < named.length; j++) {
          if (named[j].getAttribute('name') === state.focusValue) { focus = named[j]; break; }
        }
      }
      if (!focus && state.focusType === 'coupon-remove') focus = inner.querySelector('[data-hp-coupon-input]');
      if (focus && !focus.disabled) {
        try { focus.focus({ preventScroll: true }); } catch (err) { focus.focus(); }
      }
    }
    setTimeout(function () { hpRestoringDrawerView = false; }, 140);
  }

  function hpRestorePendingDrawerView() {
    if (!hpPendingDrawerView || Date.now() - hpPendingDrawerView.at > 15000) return;
    hpRestoreDrawerView(hpPendingDrawerView, false);
    requestAnimationFrame(function () {
      hpRestoreDrawerView(hpPendingDrawerView, true);
    });
  }

  function hpRememberDrawerView(event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest('cart-drawer')) return;
    var relevant = target.closest('[data-hp-add], [data-hp-coupon-submit], [data-hp-coupon-remove], cart-remove-button, .quantity__button, input[name="updates[]"]');
    if (event.type === 'submit') relevant = target.closest('[data-hp-coupon-form]');
    if (!relevant) return;
    var captured = hpCaptureDrawerView();
    if (!captured) return;
    hpPendingDrawerView = captured;
    clearTimeout(hpDrawerViewTimer);
    hpDrawerViewTimer = setTimeout(function () { hpPendingDrawerView = null; }, 15000);
  }
  document.addEventListener('click', hpRememberDrawerView, true);
  document.addEventListener('change', hpRememberDrawerView, true);
  document.addEventListener('submit', hpRememberDrawerView, true);
  /* CartItems do Sense escuta qualquer `change` dentro de cart-drawer-items e
     presume que o alvo é quantidade. Ao perder foco, o campo do cupom chegava a
     validateQuantity sem data-index e gerava um erro falso. O formulário usa
     submit, então este change específico não tem consumidor legítimo acima dele. */
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-hp-coupon-input]')) {
      event.stopPropagation();
    }
  }, true);
  document.addEventListener('scroll', function (event) {
    if (!hpPendingDrawerView || hpRestoringDrawerView) return;
    if (event.target && event.target.matches && event.target.matches('cart-drawer-items')) hpPendingDrawerView = null;
  }, true);

  /* replica o comportamento de CartDrawerItems.renderContents para as duas seções */
  function swapSections(state) {
    var drawerView = hpPendingDrawerView || hpCaptureDrawerView();
    try {
      var host = document.querySelector('cart-drawer');
      var inner = host && host.querySelector('.drawer__inner');
      if (inner && state.sections && state.sections['cart-drawer']) {
        var doc = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var freshEmpty = !!doc.querySelector('.drawer__inner-empty');
        /* guard semântico (drawer em branco 16/07): markup de carrinho vazio com o
           carrinho real cheio (ou o inverso) = resposta stale. Pintado, o inner-empty
           órfão (host sem is-empty) vira um bloco mudo de altura cheia que empurra o
           header para o rodapé — o "drawer em branco". */
        var mismatch = typeof state.itemCount === 'number' &&
          ((freshEmpty && state.itemCount > 0) || (!freshEmpty && state.itemCount === 0));
        /* nunca degradar para um drawer em branco: só troca por conteúdo substancial */
        if (fresh && fresh.children.length > 0 && !mismatch) {
          inner.innerHTML = fresh.innerHTML;
          /* o CSS do estado vazio é comandado pela classe do HOST — acompanha o markup */
          host.classList.toggle('is-empty', freshEmpty);
          hpRestoreDrawerView(drawerView, false);
          requestAnimationFrame(function () { hpRestoreDrawerView(drawerView, true); });
        }
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && state.sections && state.sections['cart-icon-bubble']) {
        var doc2 = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
        var fresh2 = doc2.querySelector('.shopify-section') || doc2.body;
        bubble.innerHTML = fresh2.innerHTML;
      }
    } catch (err) {
      log('swap falhou; recarregando estado via reload', err);
    }
    /* última linha de defesa (drawer branco relatado 14/07): se após o swap o
       drawer ficou sem conteúdo com carrinho não-vazio, recarrega a página */
    var check = document.querySelector('cart-drawer .drawer__inner');
    if (check && check.children.length === 0) window.location.reload();
    /* o swap já entregou barra/rodapé frescos — evita eco do sincronizador
       e realinha a referência de animação da bolinha */
    hpMarkSynced();
    var fillNow = document.querySelector('cart-drawer .hp-bar__fill');
    if (fillNow) hpLastWidth = fillNow.style.width;
    if (state.cart) hpRenderCoupon(state.cart);
  }

  function hpJson(url, opts, explicitRequest) {
    /* +1 na PDP: enviar o corpo fechado em Request. O interceptor de fetch do app interpreta
       init.body como novo aceite do kit selecionado e acrescenta suas variantes depois do nosso add.
       Request preserva URL, headers e quantidade enviados, sem mudar o app ou as properties da linha. */
    var input = explicitRequest ? new Request(new URL(url, window.location.href), opts) : url;
    return fetch(input, explicitRequest ? undefined : opts).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.status) {
        /* Resposta de erro do servidor (ex.: 422 no add): recusa definitiva, diferente de rede sem resposta. */
        var refused = new Error(j.description || j.message || 'cart API falhou');
        refused.hpServerRefused = true;
        throw refused;
      }
      return j;
    });
  }
  function hpSleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* Ofertas com preço fechado: códigos Basic acionados SOMENTE pelo card.
     Códigos gerenciados ficam separados dos cupons digitados pelo cliente.
     A reconciliação preserva cupons externos, reaplica todos os códigos das
     ofertas ainda válidas e remove a linha se o preço prometido não entrar. */
  var HP_CROSS_CODES = ['HPPLUS13999', 'HPX-P127-7F4K', 'HPX-P140-9Q2M', 'HPX-I998-5R8V'];
  var HP_OFFER_CODES = {
    jarra: ['JARRA-OFERTA-CARRINHO', 'HPO-JARRA-22498-K7M4'],
    garrafa: ['GARRAFA-OFERTA-CARRINHO', 'HPO-GARRAFA-107-N8Q2'],
    squeeze: ['SQUEEZE-OFERTA-CARRINHO', 'HPO-SQUEEZE-117-R5V9']
  };
  var HP_FILTER_CODES = {
    pureSteel: 'PURE-OFERTA-CARRINHO-ACO',
    pureColors: 'PURE-OFERTA-CARRINHO-CORES',
    plus: 'PLUS-OFERTA-CARRINHO'
  };
  var HP_FILTER_CODE_LIST = [HP_FILTER_CODES.pureSteel, HP_FILTER_CODES.pureColors, HP_FILTER_CODES.plus];
  var HP_ACTIVE_OFFER_CODES = [
    'HPX-P127-7F4K',
    'HPX-P140-9Q2M',
    'HPX-I998-5R8V',
    'JARRA-OFERTA-CARRINHO',
    'PURE-OFERTA-CARRINHO-ACO',
    'PURE-OFERTA-CARRINHO-CORES',
    'PLUS-OFERTA-CARRINHO',
    'GARRAFA-OFERTA-CARRINHO',
    'SQUEEZE-OFERTA-CARRINHO',
    'HPO-JARRA-22498-K7M4',
    'HPO-GARRAFA-107-N8Q2',
    'HPO-SQUEEZE-117-R5V9'
  ];
  var HP_MANAGED_CODES = HP_CROSS_CODES
    .concat(HP_FILTER_CODE_LIST)
    .concat(HP_OFFER_CODES.jarra)
    .concat(HP_OFFER_CODES.garrafa)
    .concat(HP_OFFER_CODES.squeeze);
  var HP_PRODUCT_PURE = 7636645216470;
  var HP_PRODUCT_PLUS = 8013154582742;
  var HP_PRODUCT_JARRA = 8804198613206;
  var HP_LEGACY_CROSS_TITLES = [
    'Você ganhou desconto no Hidra Plus',
    'Você ganhou desconto no Ionizador Pure'
  ];
  var HP_FILTER_BXGY_TITLE = 'Você ganhou 10% OFF no Ionizador';
  var hpOfferReconciling = false;
  var hpOfferReconcileTimer = null;
  var hpOfferSettleTimer = null;
  var hpCouponSyncTimer = null;
  var hpMutationQuietUntil = 0;
  var hpNativeMutationPending = false;
  var hpLastReconciledSignature = '';
  var hpLastReconciledAt = 0;
  var hpIgnoreDrawerMutationsUntil = 0;
  var hpCustomerCodeIntent = null;

  function hpIgnoreDrawerMutations(ms) {
    hpIgnoreDrawerMutationsUntil = Math.max(hpIgnoreDrawerMutationsUntil, Date.now() + (ms || 700));
  }

  function hpSameText(a, b) {
    return String(a || '').toLowerCase() === String(b || '').toLowerCase();
  }

  function hpIsCrossCode(code) {
    for (var i = 0; i < HP_CROSS_CODES.length; i++) {
      if (hpSameText(code, HP_CROSS_CODES[i])) return true;
    }
    return false;
  }

  function hpIsFilterCode(code) {
    return hpCodeIn(code, HP_FILTER_CODE_LIST);
  }

  function hpIsManagedCode(code) {
    for (var i = 0; i < HP_MANAGED_CODES.length; i++) {
      if (hpSameText(code, HP_MANAGED_CODES[i])) return true;
    }
    return false;
  }

  function hpIsActiveOfferCode(code) {
    for (var i = 0; i < HP_ACTIVE_OFFER_CODES.length; i++) {
      if (hpSameText(code, HP_ACTIVE_OFFER_CODES[i])) return true;
    }
    return false;
  }

  function hpCodeIn(code, candidates) {
    for (var i = 0; i < (candidates || []).length; i++) {
      if (hpSameText(code, candidates[i])) return true;
    }
    return false;
  }

  function hpOfferCode(type, storedCode) {
    var aliases = HP_OFFER_CODES[type] || [];
    return hpCodeIn(storedCode, aliases) ? storedCode : aliases[0];
  }

  function hpFilterCodeForItem(item) {
    if (!item) return '';
    if (item.product_id === HP_PRODUCT_PURE) {
      if (item.variant_id === 46277733777622) return HP_FILTER_CODES.pureSteel;
      if (item.variant_id === 46277733810390 || item.variant_id === 46277733843158) return HP_FILTER_CODES.pureColors;
    }
    if (item.product_id === HP_PRODUCT_PLUS && item.variant_id === 44057272975574) return HP_FILTER_CODES.plus;
    return '';
  }

  function hpCartCodeState(cart, wanted) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && hpSameText(codes[i].code, wanted)) return codes[i];
    }
    return null;
  }

  function hpManagedCodes(cart) {
    var out = [];
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && hpIsManagedCode(codes[i].code)) out.push(codes[i].code);
    }
    return out;
  }

  function hpCustomerCodes(cart) {
    var out = [];
    var current = cart.discount_codes || [];
    for (var i = 0; i < current.length; i++) {
      if (current[i] && current[i].code && !hpIsManagedCode(current[i].code)) out.push(current[i].code);
    }
    return out;
  }

  /* A Shopify mantém todos os códigos no mesmo campo do carrinho. Durante uma
     reconciliação de ofertas, uma resposta lida antes do clique do cliente não
     pode voltar a inserir um cupom que acabou de ser removido. A intenção fica
     somente nesta página/BFCache e é descartada se o token do carrinho mudar. */
  function hpCartToken(cart) {
    return String(cart && cart.token || '').split('?')[0];
  }

  function hpSetCustomerCodeIntent(cart, codes) {
    hpCustomerCodeIntent = {
      token: hpCartToken(cart),
      codes: hpUniqueCodes(codes || [])
    };
  }

  function hpDesiredCustomerCodes(cart) {
    if (!hpCustomerCodeIntent) return hpCustomerCodes(cart);
    if (hpCustomerCodeIntent.token && hpCartToken(cart) && hpCustomerCodeIntent.token !== hpCartToken(cart)) {
      hpCustomerCodeIntent = null;
      return hpCustomerCodes(cart);
    }
    return hpCustomerCodeIntent.codes.slice();
  }

  function hpUniqueCodes(codes) {
    var out = [];
    for (var i = 0; i < codes.length; i++) {
      var code = String(codes[i] || '').trim();
      if (!code) continue;
      var seen = false;
      for (var j = 0; j < out.length; j++) {
        if (hpSameText(out[j], code)) { seen = true; break; }
      }
      if (!seen) out.push(code);
    }
    return out;
  }

  function hpSetCartCodes(cart, managed, customer) {
    var codes = hpUniqueCodes((managed || []).concat(customer || []));
    return hpJson(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
  }

  function hpItemProp(item, name) {
    return item && item.properties ? item.properties[name] : null;
  }

  function hpProductQuantity(cart, productId) {
    var items = cart.items || [];
    var quantity = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].product_id === productId) quantity += items[i].quantity;
    }
    return quantity;
  }

  /* Bloco 3 (re-review do Codex, P2): a linha criada por um clique de card, reencontrada pela identidade
     do próprio clique (_hp_offer_click), em qualquer nome da regra e depois de mudanças de key. Duas abas
     que aceitam ao mesmo tempo nunca confirmam nem desfazem a linha da outra. */
  function hpFindClickLine(cart, variantId, rule, clickId) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === variantId && hpOfferRule(items[i]) === rule &&
        hpItemProp(items[i], '_hp_offer_click') === clickId) return items[i];
    }
    return null;
  }

  function hpFindOfferItem(cart, variantId, rule) {
    var items = cart.items || [];
    var fallback = null;
    for (var i = 0; i < items.length; i++) {
      if (hpOfferRule(items[i]) !== rule) continue;
      if (!fallback) fallback = items[i];
      if (!variantId || items[i].variant_id === variantId) return items[i];
    }
    return fallback;
  }

  /* Bloco 2 (09/10): oferta que perde o qualificador (ou não confirma depois do aceite) fica no
     carrinho a preço normal, com _hp_upsell = 'retida:<regra>'. O JS anterior só reconhece a
     regra exata — a linha retida é um item comum para ele, que nunca a apaga. Review do Codex
     (bloco 2, P1): a linha retida NÃO volta ao nome antigo ao reativar; reativa dentro de
     'retida:' com status 'active'. Assim uma escrita atrasada da aba antiga pode tirar o código,
     nunca a linha. A Jarra continua com o status 'suspended' de antes, que o JS anterior já reconhece. */
  var HP_RETAINED_PREFIX = 'retida:';
  var HP_RETAINABLE_RULES = ['carrossel:cross-plus', 'carrossel:cross-pure', 'carrossel:ionizador', 'carrossel:plus', 'carrossel:garrafa', 'carrossel:squeeze'];

  function hpRetainedRule(item) {
    var rule = String(hpItemProp(item, '_hp_upsell') || '');
    if (rule.indexOf(HP_RETAINED_PREFIX) !== 0) return '';
    rule = rule.slice(HP_RETAINED_PREFIX.length);
    return HP_RETAINABLE_RULES.indexOf(rule) === -1 ? '' : rule;
  }

  /* Bloco 3 (10/10, diretriz do dono): o Rapi é a referência das ofertas de quantidade. A cruzada que
     passa a 2+ unidades do produto recebe o kit do Rapi ("2 UNIDADES", "3 UNIDADES"), que a Shopify
     prefere ao código da cruzada na mesma linha. É compra válida, não falha: a linha passa a
     'kit:<regra>' com status 'kit', sem o código. O JS dos blocos 1 e 2 não reconhece esse nome — para
     ele a linha é item comum, que nunca apaga nem reclassifica (aba antiga deixa o kit intacto). Fim do
     kit (voltou a 1 unidade): com o qualificador o código volta e a linha reativa dentro de 'retida:'
     (mesma regra do P1 do bloco 2); sem ele, retida suspensa (T1). */
  var HP_KIT_PREFIX = 'kit:';
  var HP_KIT_RULES = ['carrossel:cross-plus', 'carrossel:cross-pure'];
  /* Bloco 3 (D1, decisão do dono 10/10): Squeeze e Garrafa não têm faixa no Rapi e o código vale R$ 20 uma vez
     por pedido. Com 2+ unidades do produto: 1 pelo preço da oferta e as demais pelo normal — vale o valor
     agregado do código, não o preço por unidade da linha. Nesse estado a linha fica em 'qtd:<regra>' (ativa):
     o JS dos blocos 1 e 2 reprovaria o preço por unidade (o do bloco 1 apagaria a linha de nome ativo); com
     'qtd:' ele só pode tirar o código, que o JS novo recoloca. De volta a 1 unidade, reativa em 'retida:'. */
  var HP_QTY_PREFIX = 'qtd:';
  var HP_QTY_RULES = ['carrossel:squeeze', 'carrossel:garrafa'];

  function hpPrefixedRule(item, prefix, rules) {
    var rule = String(hpItemProp(item, '_hp_upsell') || '');
    if (rule.indexOf(prefix) !== 0) return '';
    rule = rule.slice(prefix.length);
    return rules.indexOf(rule) === -1 ? '' : rule;
  }

  function hpKitNamedRule(item) {
    return hpPrefixedRule(item, HP_KIT_PREFIX, HP_KIT_RULES);
  }

  function hpQtyNamedRule(item) {
    return hpPrefixedRule(item, HP_QTY_PREFIX, HP_QTY_RULES);
  }

  function hpOfferRule(item) {
    return hpRetainedRule(item) || hpKitNamedRule(item) || hpQtyNamedRule(item) || hpItemProp(item, '_hp_upsell');
  }

  /* Compatibilidade com abas dos blocos 0/1: só a identidade é persistida; status continua calculado.
     Ajax change.js omitindo quantity grava 1. Storefront 2026-10 permite attributes sem quantity.
     viewKey usa a key do cart.js: se properties/descontos mudaram ou a linha saiu, recusa em vez de
     sobrescrever outro participante. Não usar o id estável do GraphQL nem fallback para change.js. */
  var HP_OFFER_PROPS = ['_hp_upsell', '_hp_offer_code', '_hp_offer_price', '_hp_offer_source', '_hp_offer_type', '_hp_offer_status', '_hp_offer_version', '_hp_offer_at', '_hp_offer_click'];
  async function hpProtectLegacyLines(cart) {
    var filterFirst = hpFirstExclusivePromise(cart) === 'filter';
    var lines = [];
    (cart.items || []).forEach(function (item) {
      var rawRule = hpItemProp(item, '_hp_upsell');
      var retain = HP_RETAINABLE_RULES.indexOf(rawRule) !== -1;
      var releaseJarra = filterFirst && item.product_id === HP_PRODUCT_JARRA &&
        (hpIsJarraOfferLine(item) || hpJarraPropertiesAllowAdoption(item));
      if (!retain && !releaseJarra) return;
      var properties = Object.assign({}, item.properties || {});
      if (retain) properties._hp_upsell = HP_RETAINED_PREFIX + rawRule;
      if (releaseJarra) {
        HP_OFFER_PROPS.forEach(function (key) { delete properties[key]; });
        properties._hp_jarra_livre = '1';
      }
      lines.push({ viewKey: item.key, attributes: Object.keys(properties).map(function (key) {
        return { key: key, value: String(properties[key] == null ? '' : properties[key]) };
      }) });
    });
    if (!lines.length) return cart;
    var shop = window.Shopify && window.Shopify.shop;
    if (!shop || !/^[a-z0-9-]+\.myshopify\.com$/.test(shop) || !cart.token || lines.length > 250) {
      throw new Error('não foi possível identificar o carrinho para proteger as ofertas anteriores');
    }
    var result = await hpJson('https://' + shop + '/api/2026-10/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: 'mutation HPProtectLegacyLines($cartId: ID!, $lines: [CartLineUpdateInput!]!) { cartLinesUpdate(cartId: $cartId, lines: $lines) { userErrors { code field message } cart { totalQuantity } } }',
        variables: { cartId: 'gid://shopify/Cart/' + cart.token, lines: lines }
      })
    });
    var update = result && result.data && result.data.cartLinesUpdate;
    if (!update || !update.cart || (result.errors && result.errors.length) || update.userErrors.length) {
      throw new Error('proteção das ofertas anteriores não confirmada; carrinho pode ter mudado');
    }
    hpMarkCartMutation(650);
    return hpJson(root() + 'cart.js');
  }

  /* Bloco 5: os códigos que dão o benefício da oferta da linha (a família do código gravado no clique). */
  function hpItemFamilyCodes(item) {
    var rule = hpOfferRule(item);
    if (rule === 'carrossel:cross-plus') return ['HPX-P127-7F4K', 'HPX-P140-9Q2M'];
    if (rule === 'carrossel:cross-pure') return ['HPX-I998-5R8V'];
    if (rule === 'carrossel:ionizador' || rule === 'carrossel:plus') {
      var filterCode = hpFilterCodeForItem(item);
      return filterCode ? [filterCode] : [];
    }
    if (rule === 'carrossel:jarra') return HP_OFFER_CODES.jarra;
    if (rule === 'carrossel:squeeze') return HP_OFFER_CODES.squeeze;
    if (rule === 'carrossel:garrafa') return HP_OFFER_CODES.garrafa;
    return [];
  }

  /* Linha sem benefício da oferta do drawer (suspensa, erro ou no kit do Rapi). Bloco 5: vem da allocation do
     código da própria oferta na linha, não de um status gravado. */
  function hpLineWithoutBenefit(item) {
    var family = hpItemFamilyCodes(item);
    for (var i = 0; i < family.length; i++) {
      if (hpAllocatedOnItemForCode(item, family[i]) > 0) return false;
    }
    return true;
  }

  /* Idade da promessa: _hp_offer_at quando as duas linhas têm; senão a posição (o carrinho lista
     a linha mais nova primeiro: índice maior = mais antiga). */
  function hpIsOlder(items, i, j) {
    var ai = Number(hpItemProp(items[i], '_hp_offer_at')) || 0;
    var aj = Number(hpItemProp(items[j], '_hp_offer_at')) || 0;
    if (ai > 0 && aj > 0 && ai !== aj) return ai < aj;
    return i > j;
  }

  function hpOldestIndex(items, test) {
    var best = -1;
    for (var i = 0; i < items.length; i++) {
      if (!test(items[i])) continue;
      if (best < 0 || hpIsOlder(items, i, best)) best = i;
    }
    return best;
  }

  /* Ionizador do card Filter com o código da própria variante, em qualquer nome (ativo ou retido). */
  function hpIsFilterLine(item) {
    var rule = hpOfferRule(item);
    var expectedCode = hpFilterCodeForItem(item);
    return (rule === 'carrossel:ionizador' || rule === 'carrossel:plus') && !!expectedCode &&
      hpSameText(hpItemProp(item, '_hp_offer_code'), expectedCode);
  }

  /* Promessa Filter que reserva a prioridade: a linha do card Filter em qualquer estado (o T5 diz que a oferta
     volta com a Jarra). Bloco 5: sem o status gravado, o "erro" deixou de ser um estado separado. */
  function hpIsFilterPromiseLine(item) {
    return hpIsFilterLine(item);
  }

  function hpHasPromisedFilterIonizer(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (hpIsFilterPromiseLine(items[i])) return true;
    }
    return false;
  }

  /* Qualquer linha Filter, inclusive em erro. */
  function hpHasFilterLine(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (hpIsFilterLine(items[i])) return true;
    }
    return false;
  }

  /* Único −10% do Filter por carrinho (review do Codex, P2): a promessa com benefício mais antiga;
     sem ela, a suspensa mais antiga. Decidida uma vez, pela idade — a perdedora fica retida, nunca
     é apagada. */
  function hpFilterHolderKey(cart) {
    var items = cart.items || [];
    var best = hpOldestIndex(items, function (item) {
      return hpIsFilterPromiseLine(item) && !hpLineWithoutBenefit(item);
    });
    if (best < 0) best = hpOldestIndex(items, hpIsFilterPromiseLine);
    return best < 0 ? '' : items[best].key;
  }

  /* Direção única nas cruzadas (parecer, M2): Pure e Plus de oferta não podem se sustentar um ao
     outro. A cruzada mais antiga do carrinho (ativa ou retida) fixa a direção; a inversa não
     qualifica. */
  function hpCrossDirection(cart) {
    var items = cart.items || [];
    var best = hpOldestIndex(items, function (item) {
      var rule = hpOfferRule(item);
      return rule === 'carrossel:cross-plus' || rule === 'carrossel:cross-pure';
    });
    return best < 0 ? '' : hpOfferRule(items[best]);
  }

  /* Unidades do produto qualificador, sem contar linha da cruzada inversa que tenha o benefício
     (a suspensa/erro é item comum a preço normal e qualifica a direção que ficou). */
  function hpCrossQualifierQuantity(cart, productId, reverseRule) {
    if (hpCrossDirection(cart) === reverseRule) return 0;
    var items = cart.items || [];
    var quantity = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].product_id !== productId) continue;
      if (hpOfferRule(items[i]) === reverseRule && !hpLineWithoutBenefit(items[i])) continue;
      quantity += items[i].quantity;
    }
    return quantity;
  }

  /* Keys mudam com properties e com descontos (Cart API), inclusive em outras linhas: depois de
     cada mutação, reencontrar a linha pela identidade da oferta, não só pela key. */
  function hpCurrentLine(cart, item) {
    var items = cart.items || [];
    if (!item) return null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === item.key) return items[i];
    }
    for (var j = 0; j < items.length; j++) {
      if (items[j].variant_id === item.variant_id &&
        hpOfferRule(items[j]) === hpOfferRule(item) &&
        String(hpItemProp(items[j], '_hp_offer_at') || '') === String(hpItemProp(item, '_hp_offer_at') || '') &&
        hpSameText(hpItemProp(items[j], '_hp_offer_code'), hpItemProp(item, '_hp_offer_code'))) return items[j];
    }
    return null;
  }

  /* Outra linha da mesma regra no carrinho, além da linha dada (ativa, retida:, qtd: ou kit:). */
  function hpOtherRuleLine(cart, item, rule) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key !== item.key && hpOfferRule(items[i]) === rule) return true;
    }
    return false;
  }

  function hpHasRuleLine(cart, rule) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (hpOfferRule(items[i]) === rule) return true;
    }
    return false;
  }

  function hpHasUndiscountedJarra(cart) {
    var items = cart.items || [];
    /* Bloco 5: a Jarra de oferta posterior à promessa Filter não é mais regravada como Jarra comum; sem a
       prioridade e sem desconto, ela é a Jarra livre que qualifica o Filter. */
    var jarraOfferFree = hpFirstExclusivePromise(cart) === 'filter';
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.product_id !== HP_PRODUCT_JARRA || item.selling_plan_allocation) continue;
      if (hpIsJarraOfferLine(item) && !jarraOfferFree) continue;
      if (Number(item.original_line_price || 0) !== Number(item.final_line_price || 0)) continue;
      var allocations = item.line_level_discount_allocations || [];
      var discounted = false;
      for (var j = 0; j < allocations.length; j++) {
        if (Number(allocations[j].amount || 0) > 0) { discounted = true; break; }
      }
      if (!discounted) return true;
    }
    return false;
  }

  function hpBeforeAddError(message) {
    var err = new Error(message);
    err.hpBeforeAdd = true;
    return err;
  }

  function hpIsJarraOfferLine(item) {
    return item.product_id === HP_PRODUCT_JARRA &&
      (hpItemProp(item, '_hp_upsell') === 'carrossel:jarra' || hpItemProp(item, '_hp_offer_source') === 'cart_drawer');
  }

  /* Rodada 3 (Codex, 09/10): Jarra de oferta e ionizador do card Filter são promessas que
     se excluem. Se as duas coexistirem (card antigo em outra aba, corrida), vence a mais
     antiga e só a posterior perde o benefício. Idade = _hp_offer_at gravado no aceite; em
     linha sem a marca, a posição (o carrinho lista a linha mais nova primeiro). */
  function hpFirstExclusivePromise(cart) {
    var items = cart.items || [];
    var jarra = hpOldestIndex(items, hpIsJarraOfferLine);
    var filter = hpOldestIndex(items, hpIsFilterPromiseLine);
    if (jarra < 0) return filter < 0 ? '' : 'filter';
    if (filter < 0) return 'jarra';
    /* Bloco 2 (review do Codex, P2): Jarra adotada não tem _hp_offer_at — numa aba com o JS
       anterior ela pode ser adotada depois de o Filter ficar suspenso; não toma a prioridade. */
    if (!Number(hpItemProp(items[jarra], '_hp_offer_at')) && Number(hpItemProp(items[filter], '_hp_offer_at'))) return 'filter';
    return hpIsOlder(items, jarra, filter) ? 'jarra' : 'filter';
  }

  /* 09/10: mesma regra do card (hp-cart-upsell.liquid, ion_filter_qualifies). O −10% do
     ionizador vale com Jarra livre e nunca depois de uma Jarra de oferta (E2). O Refil
     (dono, D1) fica para bloco próprio: qualquer estado em que só o Refil sustente a
     oferta seria apagado por uma aba aberta com o JS anterior (re-review do Codex). */
  function hpFilterQualifies(cart) {
    if (hpFirstExclusivePromise(cart) === 'jarra') return false;
    return hpHasUndiscountedJarra(cart);
  }

  function hpJarraPropertiesAllowAdoption(item) {
    var properties = item.properties || {};
    var keys = Object.keys(properties).filter(function (key) {
      return properties[key] !== null && String(properties[key]) !== '';
    });
    if (keys.length === 0) return true;
    /* O Rapi também marca a Jarra avulsa normal, sem desconto. Aceitar somente
       esse envelope conhecido; bundle real traz combo:true e allocation positiva. */
    var allowed = ['__rapi_offer', '_rapi_bundles', '_rapi_market'];
    for (var i = 0; i < keys.length; i++) {
      if (allowed.indexOf(keys[i]) === -1) return false;
    }
    if (!properties.__rapi_offer || !properties._rapi_bundles) return false;
    try {
      var offer = JSON.parse(properties.__rapi_offer);
      return offer && offer.main === true && offer.combo !== true && !!offer.id && !!offer.offer;
    } catch (err) {
      return false;
    }
  }

  function hpFindAdoptableJarra(cart) {
    if (hpProductQuantity(cart, HP_PRODUCT_PURE) < 1 && hpProductQuantity(cart, HP_PRODUCT_PLUS) < 1) return null;
    /* O card Filter → ionizador promete 10% no ionizador enquanto a Jarra é a
       qualificadora sem desconto. Adotar e descontar essa Jarra depois do clique
       invalidaria a promessa; por isso essa linha tem prioridade. A linha Filter em erro também
       bloqueia: adotar a Jarra trocaria o benefício sozinho, sem ação do cliente. */
    if (hpHasFilterLine(cart)) return null;
    var jars = (cart.items || []).filter(function (item) { return item.product_id === HP_PRODUCT_JARRA; });
    if (jars.length !== 1 || jars[0].quantity !== 1) return null;
    var item = jars[0];
    if (hpItemProp(item, '_hp_upsell') || item.selling_plan_allocation) return null;
    /* Bloco 5: a adoção é só o código (não grava a linha). Depois de aplicado, o único desconto aceito na linha é
       o do próprio código da Jarra — senão a adoção se desfaria na leitura seguinte. */
    var allocations = item.line_level_discount_allocations || [];
    var jarraAllocated = 0;
    for (var i = 0; i < allocations.length; i++) {
      if (Number(allocations[i].amount || 0) <= 0) continue;
      var app = allocations[i].discount_application || {};
      if (!hpCodeIn(app.code, HP_OFFER_CODES.jarra) && !hpCodeIn(app.title, HP_OFFER_CODES.jarra)) return null;
      jarraAllocated += Number(allocations[i].amount || 0);
    }
    if (Number(item.original_line_price || 0) - Number(item.final_line_price || 0) > jarraAllocated + 1) return null;
    /* Adoção é deliberadamente estrita: fora do envelope avulso conhecido do
       Rapi, qualquer bundle, gravação ou personalização conserva a linha normal. */
    if (!hpJarraPropertiesAllowAdoption(item)) return null;
    return item;
  }

  function hpOfferForItem(cart, item) {
    if (!item) return null;
    var rule = hpOfferRule(item);
    var storedCode = hpItemProp(item, '_hp_offer_code');
    var filterCode = hpFilterCodeForItem(item);
    var original = item.original_price || item.price || 0;
    var offer = null;

    if (rule === 'carrossel:cross-plus') {
      var bundled = hpProductQuantity(cart, HP_PRODUCT_PURE) > 1;
      var code = bundled ? 'HPX-P140-9Q2M' : 'HPX-P127-7F4K';
      if (hpSameText(storedCode, 'HPX-P140-9Q2M') || hpSameText(storedCode, 'HPX-P127-7F4K')) {
        code = storedCode;
      }
      var amount = hpSameText(code, 'HPX-P140-9Q2M') ? 5800 : 7099;
      offer = {
        code: code,
        amount: amount,
        expected: original - amount,
        qualifier: hpCrossQualifierQuantity(cart, HP_PRODUCT_PURE, 'carrossel:cross-pure') > 0,
        rule: rule,
        type: 'cross_plus'
      };
    } else if (rule === 'carrossel:cross-pure') {
      offer = {
        code: 'HPX-I998-5R8V',
        amount: 5800,
        expected: original - 5800,
        qualifier: hpCrossQualifierQuantity(cart, HP_PRODUCT_PLUS, 'carrossel:cross-plus') > 0,
        rule: rule,
        type: 'cross_pure'
      };
    } else if (rule === 'carrossel:ionizador' && item.product_id === HP_PRODUCT_PURE && filterCode && hpSameText(storedCode, filterCode)) {
      var pureExpected = Math.ceil(original * 0.9);
      offer = {
        code: filterCode,
        amount: original - pureExpected,
        expected: pureExpected,
        baseQualifier: item.product_id === HP_PRODUCT_PURE && hpFilterQualifies(cart),
        qualifier: item.product_id === HP_PRODUCT_PURE && hpFilterQualifies(cart) &&
          hpFilterHolderKey(cart) === item.key && item.quantity === 1,
        rule: rule,
        type: 'filter_pure',
        strictAllocation: true
      };
    } else if (rule === 'carrossel:plus' && item.product_id === HP_PRODUCT_PLUS && filterCode && hpSameText(storedCode, filterCode)) {
      var plusExpected = Math.ceil(original * 0.9);
      offer = {
        code: filterCode,
        amount: original - plusExpected,
        expected: plusExpected,
        baseQualifier: item.product_id === HP_PRODUCT_PLUS && hpFilterQualifies(cart),
        qualifier: item.product_id === HP_PRODUCT_PLUS && hpFilterQualifies(cart) &&
          hpFilterHolderKey(cart) === item.key && item.quantity === 1,
        rule: rule,
        type: 'filter_plus',
        strictAllocation: true
      };
    } else if (rule === 'carrossel:jarra') {
      /* Bloco 5: a oferta é de 1 Jarra e cede à promessa Filter mais antiga — sem status gravado, as duas
         condições entram no qualificador (com o ionizador presente, faltar uma delas é o antigo "erro"). */
      var ionizer = hpProductQuantity(cart, HP_PRODUCT_PURE) > 0 || hpProductQuantity(cart, HP_PRODUCT_PLUS) > 0;
      offer = {
        code: hpOfferCode('jarra', storedCode),
        aliases: HP_OFFER_CODES.jarra,
        amount: 2499,
        expected: original - 2499,
        baseQualifier: ionizer,
        qualifier: ionizer && hpFirstExclusivePromise(cart) !== 'filter' && item.quantity === 1,
        rule: rule,
        type: 'jarra'
      };
    } else if (rule === 'carrossel:garrafa') {
      offer = {
        code: hpOfferCode('garrafa', storedCode),
        aliases: HP_OFFER_CODES.garrafa,
        amount: 2000,
        expected: original - 2000,
        qualifier: hpProductQuantity(cart, HP_PRODUCT_PURE) > 0,
        rule: rule,
        type: 'garrafa'
      };
    } else if (rule === 'carrossel:squeeze') {
      offer = {
        code: hpOfferCode('squeeze', storedCode),
        aliases: HP_OFFER_CODES.squeeze,
        amount: 2000,
        expected: original - 2000,
        qualifier: hpProductQuantity(cart, HP_PRODUCT_PURE) > 0 || hpProductQuantity(cart, HP_PRODUCT_PLUS) > 0,
        rule: rule,
        type: 'squeeze'
      };
    }
    if (offer && storedCode && hpIsActiveOfferCode(storedCode)) {
      var acceptedCodes = offer.aliases || [offer.code];
      if (!hpCodeIn(storedCode, acceptedCodes)) return null;
    }
    if (offer) {
      offer.kit = hpRapiKitLine(cart, item, offer);
      offer.multi = HP_QTY_RULES.indexOf(offer.rule) !== -1 && hpProductQuantity(cart, item.product_id) > 1;
      /* baseQualifier = o produto qualificador está no carrinho. Só o Filter distingue: ele pode
         perder o benefício por não ser a titular ou por quantidade, com a Jarra livre presente. */
      if (offer.baseQualifier === undefined) offer.baseQualifier = offer.qualifier;
      /* Bloco 5: a cruzada é de 1 unidade do produto. Com 2+ vale o kit do Rapi (kit, acima); sem o kit, é o
         antigo erro depois do aceite (o código rateado não dá o preço prometido) — sem status gravado, a
         quantidade entra no qualificador para o código não voltar a cada reconciliação. */
      if (offer.type === 'cross_plus' || offer.type === 'cross_pure') {
        offer.qualifier = offer.qualifier && hpProductQuantity(cart, item.product_id) === 1;
      }
    }
    return offer;
  }

  function hpLegacyCrossApplied(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var allocations = items[i].line_level_discount_allocations || [];
      for (var j = 0; j < allocations.length; j++) {
        var app = allocations[j].discount_application || {};
        for (var k = 0; k < HP_LEGACY_CROSS_TITLES.length; k++) {
          if (allocations[j].amount > 0 && app.title === HP_LEGACY_CROSS_TITLES[k]) return true;
        }
      }
    }
    return false;
  }

  function hpAllocatedForCode(cart, code) {
    var total = 0;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var allocations = items[i].line_level_discount_allocations || [];
      for (var j = 0; j < allocations.length; j++) {
        var app = allocations[j].discount_application || {};
        if (hpSameText(app.title, code) || hpSameText(app.code, code)) {
          total += Number(allocations[j].amount || 0);
        }
      }
    }
    return total;
  }

  function hpAllocatedOnItemForCode(item, code) {
    var total = 0;
    var allocations = item && item.line_level_discount_allocations || [];
    for (var i = 0; i < allocations.length; i++) {
      var app = allocations[i].discount_application || {};
      if (hpSameText(app.title, code) || hpSameText(app.code, code)) {
        total += Number(allocations[i].amount || 0);
      }
    }
    return total;
  }

  /* Allocation do kit do Rapi (função automática "Rapi - Quantity Breaks"): sem código e com o título da
     faixa ("2 UNIDADES", "3 UNIDADES") — o mesmo marcador que o cart-drawer.liquid usa para a linha de kit.
     `/cart.js` serializa o tipo como '' e `/cart/update.js` como 'automatic'. */
  function hpRapiKitAllocation(item) {
    var total = 0;
    var allocations = item && item.line_level_discount_allocations || [];
    for (var i = 0; i < allocations.length; i++) {
      var app = allocations[i].discount_application || {};
      if ((app.type === 'automatic' || app.type === '') && !app.code && /UNIDADES/i.test(String(app.title || ''))) {
        total += Number(allocations[i].amount || 0);
      }
    }
    return total;
  }

  /* Cruzada no kit do Rapi: 2+ unidades do produto, o kit na própria linha (não o código da cruzada) e o
     benefício agregado do kit no produto ≥ o da cruzada. A Shopify escolhe o melhor desconto por linha;
     um kit que valesse menos que a cruzada perderia para o código e não chegaria aqui. Não depende do
     qualificador: o kit é do Rapi e vale sem ele. */
  function hpRapiKitLine(cart, item, offer) {
    if (!item || !offer || HP_KIT_RULES.indexOf(offer.rule) === -1) return false;
    if (hpProductQuantity(cart, item.product_id) < 2 || hpRapiKitAllocation(item) <= 0) return false;
    var family = hpOfferFamilyCodes(offer);
    for (var i = 0; i < family.length; i++) {
      if (hpAllocatedOnItemForCode(item, family[i]) > 0) return false;
    }
    var kitTotal = 0;
    var items = cart.items || [];
    for (var j = 0; j < items.length; j++) {
      if (items[j].product_id === item.product_id) kitTotal += hpRapiKitAllocation(items[j]);
    }
    return kitTotal >= offer.amount - 1;
  }

  /* Ponte de cutover: enquanto o BXGY antigo estiver ativo, a Shopify prefere o
     automático e devolve o Basic com applicable:false. Aceitar somente a
     allocation automática conhecida, na própria linha e no valor exato. Depois
     que o BXGY for encerrado, essa allocation desaparece e o Basic volta a ser
     obrigatório sem depender de flag, data ou estado mantido no navegador. */
  function hpFilterBxgyBridgeValid(item, offer, codeState) {
    if (!item || !offer || !codeState || codeState.applicable !== false) return false;
    var total = 0;
    var allocations = item.line_level_discount_allocations || [];
    for (var i = 0; i < allocations.length; i++) {
      var app = allocations[i].discount_application || {};
      /* `/cart/update.js` informa `type: automatic`, mas leituras estáveis de
         `/cart.js` podem serializar o mesmo BXGY como string vazia. Os demais
         campos do objeto identificam a regra sem confundi-la com cupom. */
      var automaticType = app.type === 'automatic' || app.type === '';
      var exactBxgy = automaticType && !app.code &&
        app.title === HP_FILTER_BXGY_TITLE &&
        String(app.value) === '10.0' &&
        app.value_type === 'percentage' &&
        app.allocation_method === 'each' &&
        app.target_selection === 'entitled' &&
        app.target_type === 'line_item';
      if (exactBxgy) {
        total += Number(allocations[i].amount || 0);
      }
    }
    return total === offer.amount && item.final_price === offer.expected;
  }

  function hpOfferStateValid(cart, item, offer) {
    if (!item || !offer || !offer.qualifier) return false;
    if ((offer.rule === 'carrossel:cross-plus' || offer.rule === 'carrossel:cross-pure') && hpLegacyCrossApplied(cart)) return false;
    var codeState = hpCartCodeState(cart, offer.code);
    if (!codeState) return false;
    /* A Shopify pode ratear o desconto fixo entre duas linhas da mesma Jarra
       (oferta do drawer + bundle Rapi). A validação correta é o valor agregado do
       código, não o final_price de uma linha isolada. */
    if (offer.type === 'jarra') {
      if (codeState.applicable === false) return false;
      var allocated = hpAllocatedForCode(cart, offer.code);
      return allocated >= offer.amount - 1;
    }
    /* Pure/Plus do card Filter precisam do desconto na própria linha. Durante o
       cutover, o único fallback aceito é o BXGY antigo com título, tipo e valor
       exatos; qualquer outra promoção continua incapaz de provar a promessa. */
    if (offer.strictAllocation) {
      var itemAllocated = hpAllocatedOnItemForCode(item, offer.code);
      var totalAllocated = hpAllocatedForCode(cart, offer.code);
      if (codeState.applicable !== false && itemAllocated >= offer.amount - 1 && totalAllocated <= offer.amount + 1) {
        return true;
      }
      return hpFilterBxgyBridgeValid(item, offer, codeState);
    }
    /* Se outro desconto legítimo der preço ainda menor, a promessa foi cumprida.
       O código pode aparecer como não aplicável porque a Shopify escolheu o melhor. */
    if (item.final_price <= offer.expected) return true;
    /* Bloco 3 (D1): Squeeze/Garrafa com 2+ unidades — o código inteiro aplicado (rateado entre as linhas do
       produto, se houver mais de uma) cumpre "1 pelo preço da oferta + as demais pelo normal". */
    if (offer.multi) return codeState.applicable !== false && hpAllocatedForCode(cart, offer.code) >= offer.amount - 1;
    return false;
  }

  function hpOfferItems(cart) {
    var out = [];
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (hpOfferForItem(cart, items[i])) out.push(items[i]);
    }
    return out;
  }

  function hpDesiredManagedCodes(cart, skipKey) {
    var items = hpOfferItems(cart);
    var out = [];
    for (var i = 0; i < items.length; i++) {
      if (skipKey && items[i].key === skipKey) continue;
      var offer = hpOfferForItem(cart, items[i]);
      if (offer && offer.qualifier && !offer.kit) out.push(offer.code);
    }
    /* Bloco 5: a Jarra avulsa (PDP) com ionizador recebe a oferta só pelo código — sem regravar a linha. */
    if (hpFindAdoptableJarra(cart)) out.push(hpOfferCode('jarra', ''));
    return hpUniqueCodes(out);
  }

  function hpSameCodeSet(a, b) {
    a = hpUniqueCodes(a);
    b = hpUniqueCodes(b);
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      var found = false;
      for (var j = 0; j < b.length; j++) {
        if (hpSameText(a[i], b[j])) { found = true; break; }
      }
      if (!found) return false;
    }
    return true;
  }

  /* Códigos da família da oferta: aliases e, no Plus cruzado, as duas tabelas. */
  function hpOfferFamilyCodes(offer) {
    if (offer.type === 'cross_plus') return ['HPX-P127-7F4K', 'HPX-P140-9Q2M'];
    return offer.aliases || [offer.code];
  }

  /* Bloco 5: status da linha de oferta calculado do carrinho e dos descontos aplicados (substitui _hp_offer_status
     e os prefixos retida:/kit:/qtd:, que continuam só sendo lidos). Mesma regra no cart-drawer.liquid (avisos).
       kit       — o kit do Rapi vale na linha (hpRapiKitLine);
       suspended — sem o produto qualificador (T1–T5);
       error     — com o qualificador, mas sem direito (Filter não titular, quantidade) ou sem o desconto aplicado;
       active    — a promessa vale (hpOfferStateValid). */
  function hpOfferStatus(cart, item, offer) {
    offer = offer || hpOfferForItem(cart, item);
    if (!offer) return '';
    if (offer.kit) return 'kit';
    if (!offer.baseQualifier) return 'suspended';
    if (!offer.qualifier || !hpOfferStateValid(cart, item, offer)) return 'error';
    return 'active';
  }

  function hpOfferLineId(item) {
    return [item.variant_id, hpOfferRule(item), hpItemProp(item, '_hp_offer_at') || '', hpItemProp(item, '_hp_offer_click') || ''].join('|');
  }

  function hpActiveOfferIds(cart) {
    return hpOfferItems(cart).filter(function (item) {
      return hpOfferStatus(cart, item) === 'active';
    }).map(hpOfferLineId);
  }

  /* Cupom e checkout: nenhuma oferta que valia antes da mudança de códigos deixou de valer depois. Oferta que já
     não valia (código recusado, sem direito) é estado de compra válido — o aviso na linha mostra o preço real. */
  function hpOffersKept(before, after) {
    var now = hpActiveOfferIds(after);
    return hpActiveOfferIds(before).every(function (id) { return now.indexOf(id) !== -1; });
  }

  function hpCartSignature(cart) {
    var items = (cart.items || []).map(function (item) {
      return [
        item.product_id,
        item.variant_id,
        item.quantity,
        item.original_line_price,
        item.final_line_price,
        hpItemProp(item, '_hp_upsell') || '',
        hpItemProp(item, '_hp_offer_status') || '',
        hpItemProp(item, '_hp_offer_code') || ''
      ].join(':');
    }).sort();
    var codes = (cart.discount_codes || []).map(function (entry) {
      return [entry.code, entry.applicable].join(':');
    }).sort();
    return [cart.item_count, cart.total_price, items.join('|'), codes.join('|')].join('::');
  }

  function hpMarkCartMutation(ms) {
    hpMutationQuietUntil = Math.max(hpMutationQuietUntil, Date.now() + (ms || 2100));
  }

  async function hpReadStableCart(reason, maxAttempts) {
    var quietFor = hpMutationQuietUntil - Date.now();
    if (quietFor > 0) await hpSleep(Math.min(quietFor, 2400));
    var previous = '';
    var cart = null;
    var attempts = maxAttempts || 7;
    for (var attempt = 0; attempt < attempts; attempt++) {
      cart = await hpJson(root() + 'cart.js?_hp=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
      var signature = hpCartSignature(cart);
      if (signature === previous) {
        log('carrinho estável', reason, attempt + 1);
        return cart;
      }
      previous = signature;
      if (attempt < attempts - 1) await hpSleep(260 + attempt * 90);
    }
    log('limite de estabilização atingido', reason);
    return cart;
  }

  function hpShowCartMessage(message, isError) {
    var node = document.querySelector('[data-hp-cart-message]');
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
    node.classList.toggle('hp-cart-message--error', !!isError);
  }

  async function hpApplyAndVerifyOffer(code, expected, variantId, rule, clickId) {
    /* R3 (09/10): o preço do card é a promessa do clique. A regra do JS continua
       valendo, mas não pode substituir a promessa: se as duas divergirem (setting do
       editor × constante), a oferta não é confirmada. */
    var promised = expected;
    var cart = await hpJson(root() + 'cart.js');
    var desired = hpDesiredManagedCodes(cart);
    if (hpIsCrossCode(code)) {
      desired = desired.filter(function (candidate) { return !hpIsCrossCode(candidate); });
      desired.push(code);
    } else if (hpIsFilterCode(code)) {
      desired = desired.filter(function (candidate) { return !hpIsFilterCode(candidate); });
      desired.push(code);
    } else {
      desired.push(code);
    }
    cart = await hpSetCartCodes(cart, desired, hpDesiredCustomerCodes(cart));
    hpMarkCartMutation(1900);
    for (var attempt = 0; attempt < 5; attempt++) {
      if (attempt > 0) {
        await hpSleep(280 + attempt * 140);
        cart = await hpJson(root() + 'cart.js?_hp=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
      }
      var item = clickId ? hpFindClickLine(cart, variantId, rule, clickId) : hpFindOfferItem(cart, variantId, rule);
      var offer = hpOfferForItem(cart, item);
      if (offer) expected = offer.expected;
      if (offer && promised > 0 && Math.abs(offer.expected - promised) > 1) {
        throw new Error('preço do card diverge da regra da oferta: ' + promised + ' × ' + offer.expected);
      }
      /* Bloco 3 (D1): com 2+ unidades do produto, vale o código rateado (Squeeze da PDP + card). A oferta da
         Squeeze/Garrafa é de 1 unidade por carrinho: outra linha da mesma regra é outra promessa (aba sem a trava
         entre abas, ou com o JS anterior) e este clique não confirma — nem pelo rateio, nem pelo preço; a linha fica e
         a aba exige atualizar a página (3º re-review). A que confirmou sozinha antes continua valendo (2º re-review, P2). */
      var rival = !!item && HP_QTY_RULES.indexOf(rule) !== -1 && hpOtherRuleLine(cart, item, rule);
      if (item && offer && !rival && hpSameText(offer.code, code) && hpOfferStateValid(cart, item, offer) &&
        (offer.type === 'jarra' || offer.multi || item.final_price <= expected)) {
        /* Bloco 5: confirmado, sem escrita na linha (o status é calculado; o 'active' do add fica como registro). */
        log('oferta validada', code, item.final_price);
        return cart;
      }
    }
    throw new Error('desconto da oferta não foi aplicado na linha prometida');
  }

  /* Bloco 3 (3º re-review do Codex, P2): o aceite que não confirmou não escreve em linha nenhuma — nem remove a
     unidade, nem marca a linha. A Cart API não tem escrita condicional, e toda escrita de linha leva quantidade
     absoluta: sem `quantity`, a Shopify grava 1 (medido em harness/props-sem-quantidade.mjs). Qualquer escrita aqui
     poderia desfazer um "+" de outra aba ou do /cart que chegasse na janela da requisição. A linha do clique fica
     como entrou; a reconciliação resolve o estado (código reaplicado, D1, retida ou erro) e esta aba exige
     atualizar a página antes do checkout. Aqui só se lê o carrinho, para o aviso dizer a verdade (add confirmado
     ou recusado pelo servidor; com rede incerta no add a linha pode chegar depois e nem se lê: vale o aviso). */
  async function hpClickLineInCart(variantId, rule, clickId) {
    var cart = await hpJson(root() + 'cart.js?_hp=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
    return !!hpFindClickLine(cart, variantId, rule, clickId);
  }

  /* Textos aprovados pelo dono (12/10), literais. */
  var HP_OFFER_UNCONFIRMED_MSG = 'Não foi possível confirmar a oferta.';
  var HP_OFFER_RELOAD_LABEL = 'Aplicar oferta';
  /* O loader lê esta chave na página recarregada e reabre o drawer (o bundle só carrega com ele aberto). */
  var HP_REOPEN_KEY = 'hp-cart-reabrir';
  var hpOfferUnconfirmed = false;

  /* Vale até a página recarregar: o re-render do drawer (desta aba ou do Sense) não devolve o checkout. Idempotente
     (só escreve no DOM o que falta), porque também roda no MutationObserver do drawer.
     Bloco 3.1 (dono, 12/10): o público é leigo e compra muito pelo navegador do Instagram/Facebook, que não mostra o
     botão de recarregar. O aviso fica logo acima do checkout (rodapé fixo, sempre à vista), com o botão que faz o
     reload pelo cliente; a página recarregada reconcilia (código, D1, retida ou erro), como no 5º re-review. */
  function hpKeepOfferUnconfirmed() {
    if (!hpOfferUnconfirmed) return;
    var checkout = document.querySelector('cart-drawer button[name="checkout"]');
    if (checkout && !checkout.disabled) checkout.disabled = true;
    if (!checkout || document.querySelector('cart-drawer [data-hp-offer-unconfirmed]')) return;
    var anchor = checkout.closest('.cart__ctas') || checkout;
    var box = document.createElement('div');
    box.setAttribute('data-hp-offer-unconfirmed', '');
    box.style.marginBottom = '1rem';
    var message = document.createElement('p');
    message.className = 'hp-cart-message hp-cart-message--error';
    message.setAttribute('role', 'alert');
    message.style.margin = '0 0 0.8rem';
    message.textContent = HP_OFFER_UNCONFIRMED_MSG;
    var reload = document.createElement('button');
    reload.type = 'button';
    reload.className = 'button button--full-width';
    reload.setAttribute('data-hp-offer-reload', '');
    reload.textContent = HP_OFFER_RELOAD_LABEL;
    /* mesma letra e altura do checkout (o CSS do bundle não muda neste bloco) */
    var look = window.getComputedStyle && window.getComputedStyle(checkout);
    if (look) {
      reload.style.fontWeight = look.fontWeight;
      reload.style.minHeight = look.minHeight;
    }
    box.appendChild(message);
    box.appendChild(reload);
    anchor.parentNode.insertBefore(box, anchor);
  }

  function hpShowOfferError(rule, message) {
    var cards = document.querySelectorAll('[data-hp-card-rule]');
    var shown = false;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-hp-card-rule') !== rule) continue;
      var error = cards[i].querySelector('[data-hp-error]');
      if (error) {
        error.hidden = false;
        error.textContent = message;
        shown = true;
      }
    }
    /* Rodada 3: card desatualizado recusado some no re-render — o aviso vai para a
       mensagem geral do carrinho para o clique não ficar sem resposta. */
    if (!shown && message) hpShowCartMessage(message, true);
  }

  function hpScheduleOfferReconcile(reason) {
    clearTimeout(hpOfferReconcileTimer);
    hpOfferReconcileTimer = setTimeout(function () {
      hpOfferReconcileTimer = null;
      hpReconcileOffers(reason);
    }, 520);
  }

  function hpScheduleOfferSettle(reason, delay) {
    clearTimeout(hpOfferSettleTimer);
    hpOfferSettleTimer = setTimeout(function () {
      hpOfferSettleTimer = null;
      hpSyncBar();
      hpScheduleCouponSync(80);
      hpScheduleOfferReconcile(reason);
    }, delay || 1100);
  }

  async function hpReconcileOffers(reason) {
    /* 4º re-review do Codex (P2): depois de um aceite não confirmado, esta aba não escreve mais no carrinho até
       recarregar — nem linha, nem código. Toda escrita de linha leva quantidade absoluta e desfaria um "+" de outra
       aba ou do /cart que chegasse na janela; o estado é resolvido pela página recarregada (ou por outra aba). */
    if (hpOfferUnconfirmed) {
      hpNativeMutationPending = false;
      hpUpdateBusyUI();
      log('aceite não confirmado nesta aba: reconciliação suspensa até recarregar', reason);
      return;
    }
    if (hpOfferReconciling) {
      hpScheduleOfferReconcile(reason + ':ocupado');
      return;
    }
    if (typeof hpMutationPending === 'number' && hpMutationPending > 0) {
      hpScheduleOfferReconcile(reason + ':fila');
      return;
    }
    hpOfferReconciling = true;
    var changed = false;
    try {
      var cart = await hpReadStableCart('reconciliar:' + reason, 7);
      var startingSignature = hpCartSignature(cart);
      /* Bloco 3: o "+"/"−" nativo pode responder depois da leitura agendada pelo clique, e o re-render do
         Sense cair na janela em que a barra ignora mutações (hpSyncBar) — sem nova leitura, o kit do Rapi ou a
         volta da cruzada (2 → 1) só se resolveria no próximo evento. Carrinho igual ao já reconciliado logo
         depois de um controle nativo: uma leitura tardia, uma vez só. */
      if (/^cart-(control|quantity)/.test(reason) && reason.indexOf(':tardia') === -1 &&
        startingSignature === hpLastReconciledSignature) {
        hpScheduleOfferSettle(reason + ':tardia', 1500);
      }
      if ((reason.indexOf('drawer-mutation') !== -1 || reason.indexOf('drawer-settled') !== -1) &&
        startingSignature === hpLastReconciledSignature &&
        Date.now() - hpLastReconciledAt < 12000) {
        return;
      }
      if (hpOfferItems(cart).length === 0 && hpManagedCodes(cart).length === 0 && !hpFindAdoptableJarra(cart)) {
        hpLastReconciledSignature = startingSignature;
        hpLastReconciledAt = Date.now();
        return;
      }
      /* Migração de identidade, sem reenviar quantidade. Idempotente: linhas protegidas não geram escrita.
         A Jarra cedida ao Filter fica livre também para abas antigas, que não podem adotá-la de novo. */
      var migrationFailed = false;
      try {
        var protectedCart = await hpProtectLegacyLines(cart);
        if (protectedCart !== cart) changed = true;
        cart = protectedCart;
      } catch (migrationError) {
        migrationFailed = true;
        /* Falha de compatibilidade não suspende os códigos: seguir com a leitura disponível,
           sem retry nem fallback que reenvie quantidade. A identidade pode continuar legada. */
        log('proteção das ofertas anteriores falhou; mantendo gestão dos códigos', reason, migrationError);
      }
      /* A primeira leitura já aguardou o fluxo nativo estabilizar; cart/update devolve o carrinho
         canônico e a resposta é reutilizada na passada seguinte. Tirar um código pode liberar um qualificador (ex.: Jarra liberada deixa de ter desconto e
         volta a qualificar o Filter): repetir até o conjunto desejado parar de mudar. */
      for (var pass = 0; pass < 3; pass++) {
        var desired = hpDesiredManagedCodes(cart);
        var desiredCustomer = hpDesiredCustomerCodes(cart);
        var customerIntentMismatch = !!hpCustomerCodeIntent && !hpSameCodeSet(hpCustomerCodes(cart), desiredCustomer);
        if (hpSameCodeSet(hpManagedCodes(cart), desired) && !customerIntentMismatch) break;
        cart = await hpSetCartCodes(cart, desired, desiredCustomer);
        hpMarkCartMutation(650);
        changed = true;
      }

      cart = await hpJson(root() + 'cart.js');
      /* Não suprimir o próximo evento existente quando a identidade ficou pendente. */
      hpLastReconciledSignature = migrationFailed ? '' : hpCartSignature(cart);
      hpLastReconciledAt = Date.now();
    } catch (err) {
      log('reconciliação das ofertas falhou', reason, err);
    } finally {
      hpOfferReconciling = false;
      hpNativeMutationPending = false;
      hpUpdateBusyUI();
    }
    /* Avisos de oferta retida/suspensa vêm na própria linha (cart-drawer.liquid) e
       sobrevivem a reload/BFCache; não há mais mensagem transitória aqui. */
    if (changed) hpRefreshDrawer('ofertas:' + reason);
  }

  /* BFCache / WebView: ao voltar do checkout, o navegador pode restaurar o DOM
     congelado sem disparar DOMContentLoaded. Reconciliar as duas seções com o
     cart.js real evita ícone/drawer visualmente vazios com itens ainda no servidor. */
  /* Review do Codex (bloco 2, P2): duas pinturas em voo (volta do checkout + reconciliação) podem
     responder fora de ordem. Cada pintura tem uma geração; resposta de geração superada é descartada. */
  var hpPaintGeneration = 0;
  function hpRefreshDrawer(reason, retry) {
    retry = retry || 0;
    var generation = ++hpPaintGeneration;
    var stamp = Date.now();
    var opts = { credentials: 'same-origin', cache: 'no-store' };
    return Promise.all([
      hpJson(root() + '?sections=cart-drawer,cart-icon-bubble&_hp=' + stamp, opts),
      hpJson(root() + 'cart.js?_hp=' + stamp, opts)
    ]).then(function (pair) {
      var sections = pair[0];
      var cartState = pair[1];
      var html = sections && sections['cart-drawer'];
      if (!html || typeof cartState.item_count !== 'number') throw new Error('estado do carrinho incompleto');

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshEmpty = !!doc.querySelector('.drawer__inner-empty');
      var mismatch = (freshEmpty && cartState.item_count > 0) || (!freshEmpty && cartState.item_count === 0);
      if (mismatch && retry < 1) {
        return hpSleep(180).then(function () { return hpRefreshDrawer(reason, retry + 1); });
      }
      if (mismatch) throw new Error('section stale após nova tentativa');
      if (generation !== hpPaintGeneration) {
        log('pintura superada descartada', reason);
        return cartState;
      }

      /* swapSections e hpSyncBar alteram o próprio drawer. O observer existe para
         mudanças externas (Sense/Rapi), portanto não deve transformar nosso
         re-render em uma nova rodada infinita de rede. */
      hpIgnoreDrawerMutations(900);
      swapSections({ sections: sections, itemCount: cartState.item_count, cart: cartState });
      if (window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cartState });
      }
      log('drawer reconciliado', reason, cartState.item_count);
      return cartState;
    }).catch(function (err) {
      log('reconciliação do drawer falhou', reason, err);
      return null;
    });
  }

  /* sincronizador da barra/rodapé (bug 15/07: barra não andava): a hp-bar e o
     hp-totals vivem FORA de cart-drawer-items, e fluxos que re-renderizam só os
     itens (onCartUpdate do tema, apps de bundle como o Rapi) os deixavam stale.
     Qualquer sinal de mudança → re-render dos dois blocos via Section Rendering
     API. Debounce + guard de ciclo evitam eco do próprio replace. */
  var hpSyncBusy = false;
  var hpLastSync = 0;
  var hpLastWidth = null;
  function hpMarkSynced() { hpLastSync = Date.now(); }
  /* anima o progresso mesmo quando o TEMA recria a barra já no estado final
     (stepper): volta ao width anterior sem transição e anima até o novo */
  function hpAnimateFill(fillEl, targetW) {
    if (fillEl.style.width !== targetW) {
      fillEl.style.width = targetW;
    } else if (hpLastWidth !== null && hpLastWidth !== targetW) {
      fillEl.style.transition = 'none';
      fillEl.style.width = hpLastWidth;
      void fillEl.offsetWidth;
      fillEl.style.transition = '';
      fillEl.style.width = targetW;
    }
    hpLastWidth = targetW;
  }
  function hpSyncBar() {
    if (hpSyncBusy) return;
    if (Date.now() - hpLastSync < 400) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    hpSyncBusy = true;
    hpMarkSynced();
    hpJson(root() + '?sections=cart-drawer').then(function (sections) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var innerCur = drawer.querySelector('.drawer__inner');
      if (!innerCur) return;
      var pairs = [
        { sel: '.hp-bar', anchor: 'cart-drawer-items', where: 'before' },
        { sel: '.hp-totals', anchor: '.drawer__footer', where: 'prepend' }
      ];
      for (var i = 0; i < pairs.length; i++) {
        var cur = innerCur.querySelector(pairs[i].sel);
        var fresh = doc.querySelector(pairs[i].sel);
        if (cur && fresh) {
          hpIgnoreDrawerMutations(700);
          if (pairs[i].sel === '.hp-bar') {
            /* barra atualiza IN-PLACE (não recria o nó): a transition CSS do
               width anima a bolinha do progresso (pedido do fundador 15/07) */
            var cf = cur.querySelector('.hp-bar__fill');
            var ff = fresh.querySelector('.hp-bar__fill');
            if (cf && ff) hpAnimateFill(cf, ff.style.width);
            var cm = cur.querySelector('.hp-bar__msg');
            var fm = fresh.querySelector('.hp-bar__msg');
            if (cm && fm && cm.innerHTML !== fm.innerHTML) cm.innerHTML = fm.innerHTML;
            var ck = cur.querySelector('.hp-bar__marks');
            var fk = fresh.querySelector('.hp-bar__marks');
            if (ck && fk && ck.innerHTML !== fk.innerHTML) ck.innerHTML = fk.innerHTML;
          } else {
            if (cur.outerHTML !== fresh.outerHTML) cur.outerHTML = fresh.outerHTML;
          }
        } else if (cur && !fresh) {
          cur.parentNode.removeChild(cur);
        } else if (!cur && fresh) {
          var anchor = innerCur.querySelector(pairs[i].anchor);
          if (!anchor) continue;
          var node = document.createElement('div');
          node.innerHTML = fresh.outerHTML;
          node = node.firstChild;
          if (pairs[i].where === 'before') anchor.parentNode.insertBefore(node, anchor);
          else anchor.insertBefore(node, anchor.firstChild);
        }
      }
      log('barra sincronizada');
    }).catch(function (err) {
      log('sync da barra falhou', err);
    }).then(function () {
      hpMarkSynced();
      hpSyncBusy = false;
    });
  }
  function hpScheduleCouponSync(delay) {
    clearTimeout(hpCouponSyncTimer);
    hpCouponSyncTimer = setTimeout(function () {
      hpJson(root() + 'cart.js?_hp=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' })
        .then(function (cart) { hpRenderCoupon(cart); })
        .catch(function (err) { log('sync do cupom falhou', err); });
    }, delay || 180);
  }
  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(hpSyncBar, 60);
      hpScheduleOfferReconcile('pubsub');
      hpScheduleCouponSync(220);
    });
  }
  function hpInitDrawerSync() {
    var f0 = document.querySelector('cart-drawer .hp-bar__fill');
    if (f0) hpLastWidth = f0.style.width;
    var drawer = document.querySelector('cart-drawer');
    hpScheduleOfferReconcile('dom-ready');
    if (!drawer || !('MutationObserver' in window)) return;
    /* apps fora do pub-sub (Rapi) e alguns fluxos nativos do Sense re-renderizam
       os itens direto no DOM. Além de barra/rodapé, esse é o sinal universal para
       revalidar o vínculo de cada oferta com o produto-base. Sem esta chamada,
       remover o Pure pelo ícone de lixeira podia deixar uma oferta promocional órfã
       quando o cartUpdate não estava disponível no instante em que este asset
       carregou. O debounce + hpOfferReconciling impedem ciclos no próprio swap. */
    new MutationObserver(function (mutations) {
      /* Re-render do Sense devolve o checkout e some com o aviso: aceite não confirmado continua valendo. */
      hpKeepOfferUnconfirmed();
      var structural = mutations.some(function (mutation) {
        var target = mutation.target && mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target && mutation.target.parentElement;
        if (!target || !target.matches) return false;
        if (target.matches('.drawer__inner, #CartDrawer-CartItems')) return true;
        var nodes = [].slice.call(mutation.addedNodes || []).concat([].slice.call(mutation.removedNodes || []));
        return nodes.some(function (node) {
          return node.nodeType === 1 && (node.matches('cart-drawer-items') || !!node.querySelector('cart-drawer-items'));
        });
      });
      /* O primeiro re-render pode ser o do Sense, antes da reconciliação HP. A
         posição original capturada no gesto impede o salto intermediário. */
      if (structural) hpRestorePendingDrawerView();
      if (Date.now() < hpIgnoreDrawerMutationsUntil) return;
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target && mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target && mutation.target.parentElement;
        if (!target || !target.closest) return false;
        return !target.closest('.hp-bar, .hp-totals, .hp-coupon, .hp-cart-message, .hp-teaser, button[name="checkout"]');
      });
      if (!relevant) return;
      /* O Sense pode mutar o contador antes de o cart/change.js terminar. Uma
         segunda leitura após o drawer estabilizar fecha essa janela de corrida. */
      hpScheduleOfferSettle('drawer-settled', 1200);
    }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hpInitDrawerSync, { once: true });
  } else {
    hpInitDrawerSync();
  }

  /* Guarda complementar: alguns remove/quantity flows não fazem uma mutação DOM
     após a resposta de rede. O clique/change ainda garante uma leitura tardia do
     carrinho real e remove uma oferta que perdeu o produto-base. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('cart-drawer')) return;
    if (!event.target.closest('cart-remove-button, .quantity__button')) return;
    if (document.querySelector('cart-drawer [data-hp-offer-line="true"]')) {
      hpNativeMutationPending = true;
      hpMarkCartMutation(900);
      hpUpdateBusyUI();
    }
    hpScheduleOfferSettle('cart-control', 700);
  }, true);
  document.addEventListener('change', function (event) {
    if (!event.target.closest('cart-drawer')) return;
    if (!event.target.matches('input[name="updates[]"]')) return;
    if (document.querySelector('cart-drawer [data-hp-offer-line="true"]')) {
      hpNativeMutationPending = true;
      hpMarkCartMutation(900);
      hpUpdateBusyUI();
    }
    hpScheduleOfferSettle('cart-quantity', 700);
  }, true);

  /* O bundle carrega sob demanda (hp-cart-upsell-loader.js): numa volta do checkout ele pode chegar
     depois do pageshow, com o HTML antigo do carrinho na tela (até "vazio" com 3 itens no servidor).
     Ao iniciar numa navegação back_forward, ou marcada pelo loader, ressincroniza o drawer. */
  (function () {
    var nav = window.performance && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')[0]
      : null;
    if (!window.__hpCartUpsellRestored && (!nav || nav.type !== 'back_forward')) return;
    window.__hpCartUpsellRestored = false;
    hpRefreshDrawer('init:volta');
  })();

  window.addEventListener('pageshow', function (event) {
    hpScheduleOfferReconcile('pageshow');
    var nav = window.performance && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')[0]
      : null;
    if (!event.persisted && (!nav || nav.type !== 'back_forward')) return;
    hpSyncBusy = false;
    hpRefreshDrawer(event.persisted ? 'pageshow:bfcache' : 'pageshow:back-forward');
  });

  /* Todas as ofertas HP compartilham uma única fila. Botões diferentes ainda
     podem ser acionados em sequência rápida, mas cada mutação só começa depois
     que a anterior confirmou e re-renderizou o estado real do carrinho. */
  var hpMutationQueue = Promise.resolve();
  var hpMutationPending = 0;
  var hpCheckoutValidationPending = false;
  var hpCheckoutAllowOnce = false;
  function hpUpdateBusyUI() {
    var host = document.querySelector('cart-drawer');
    var busy = hpMutationPending > 0 || hpNativeMutationPending || hpOfferReconciling;
    if (host) host.toggleAttribute('aria-busy', busy);
    var checkout = document.querySelector('cart-drawer button[name="checkout"]');
    if (!checkout) return;
    if (busy) {
      if (!checkout.getAttribute('data-hp-original-label')) {
        checkout.setAttribute('data-hp-original-label', checkout.textContent.trim());
      }
      checkout.textContent = 'Confirmando descontos…';
      checkout.disabled = true;
    } else {
      var original = checkout.getAttribute('data-hp-original-label');
      if (original) checkout.textContent = original;
      checkout.removeAttribute('data-hp-original-label');
      checkout.disabled = false;
      hpKeepOfferUnconfirmed();
    }
  }

  function hpEnqueueMutation(task) {
    hpMutationPending += 1;
    hpUpdateBusyUI();

    var run = hpMutationQueue.then(async function () {
      /* Uma reconciliação já iniciada pode ter lido códigos antigos. Esperar seu
         término garante que a mutação explícita do cliente seja sempre a última. */
      for (var attempt = 0; hpOfferReconciling && attempt < 80; attempt++) {
        await hpSleep(50);
      }
      if (hpOfferReconciling) throw new Error('reconciliação do carrinho não terminou a tempo');
      var quietFor = hpMutationQuietUntil - Date.now();
      if (hpNativeMutationPending && quietFor > 0) await hpSleep(Math.min(quietFor, 2400));
      return task();
    }, task);
    hpMutationQueue = run.catch(function (err) { log('fila de mutações falhou', err); });
    hpMutationQueue.then(function () {
      hpMutationPending -= 1;
      hpUpdateBusyUI();
    });
    return run;
  }

  /* Bloco 3 (2º re-review do Codex, P2): a fila acima é por aba; o aceite de um card é uma transação entre abas
     (releitura da elegibilidade, add e confirmação). A trava do navegador (Web Locks, mesma origem)
     serializa os aceites de todas as abas com este JS: a segunda relê o carrinho já com a oferta da primeira e é
     recusada antes do add. Espera limitada: passou do prazo, nada é adicionado. Sem a API (navegador antigo) ou
     com ela recusada, segue sem trava — o verify ainda recusa uma 2ª linha da mesma oferta de quantidade. */
  var HP_OFFER_LOCK = 'hp-cart-offer-accept';
  var HP_OFFER_LOCK_WAIT = 12000;
  function hpAcquireOfferLock() {
    var locks = window.navigator && window.navigator.locks;
    if (!locks || typeof locks.request !== 'function') return Promise.resolve(function () {});
    return new Promise(function (resolve, reject) {
      var expired = false;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = setTimeout(function () {
        expired = true;
        if (controller) controller.abort();
        reject(hpBeforeAddError('outra aba ainda está aplicando uma oferta'));
      }, HP_OFFER_LOCK_WAIT);
      Promise.resolve().then(function () {
        return locks.request(HP_OFFER_LOCK, controller ? { signal: controller.signal } : {}, function () {
          if (expired) return null;
          clearTimeout(timer);
          return new Promise(function (release) { resolve(release); });
        });
      }).catch(function (err) {
        if (expired) return;
        clearTimeout(timer);
        log('trava entre abas indisponível; seguindo sem ela', err);
        resolve(function () {});
      });
    });
  }

  /* Bloco 3.1: o botão do aviso faz o reload que a aba travada exige e pede ao loader o drawer aberto de volta. */
  document.addEventListener('click', function (event) {
    var reload = event.target.closest('[data-hp-offer-reload]');
    if (!reload || !hpOfferUnconfirmed) return;
    event.preventDefault();
    reload.disabled = true;
    try { window.sessionStorage.setItem(HP_REOPEN_KEY, String(Date.now())); } catch (e) {}
    window.location.reload();
  });

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('cart-drawer button[name="checkout"]');
    if (!checkout) return;
    /* Aceite não confirmado nesta aba: checkout só depois de atualizar a página (3º re-review do Codex). */
    if (hpOfferUnconfirmed) {
      hpCheckoutAllowOnce = false;
      event.preventDefault();
      event.stopImmediatePropagation();
      hpKeepOfferUnconfirmed();
      return;
    }
    if (hpCheckoutAllowOnce) {
      hpCheckoutAllowOnce = false;
      return;
    }
    if (hpMutationPending > 0 || hpNativeMutationPending || hpOfferReconciling) {
      event.preventDefault();
      event.stopImmediatePropagation();
      hpShowCartMessage('Confirmando os descontos do carrinho…', false);
      return;
    }
    /* Só acrescenta uma confirmação quando o cliente alterou o cupom nesta
       página. O fluxo comum continua nativo, sem atraso adicional. */
    if (!hpCustomerCodeIntent) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (hpCheckoutValidationPending) return;
    hpCheckoutValidationPending = true;
    hpShowCartMessage('Confirmando os descontos do carrinho…', false);

    hpEnqueueMutation(async function () {
      var cart = await hpReadStableCart('checkout:cupom', 4);
      var start = cart;
      var managed = hpDesiredManagedCodes(cart);
      var customer = hpDesiredCustomerCodes(cart);
      if (!hpSameCodeSet(hpManagedCodes(cart), managed) || !hpSameCodeSet(hpCustomerCodes(cart), customer)) {
        cart = await hpSetCartCodes(cart, managed, customer);
        hpMarkCartMutation(650);
        cart = await hpReadStableCart('checkout:cupom-corrigido', 4);
      }
      if (!hpSameCodeSet(hpManagedCodes(cart), managed) || !hpSameCodeSet(hpCustomerCodes(cart), customer)) {
        throw new Error('os códigos do carrinho divergiram antes do checkout');
      }
      if (!hpOffersKept(start, cart)) throw new Error('uma oferta perdeu o preço antes do checkout');
    }).then(function () {
      return hpMutationQueue;
    }).then(function () {
      hpCheckoutValidationPending = false;
      var current = document.querySelector('cart-drawer button[name="checkout"]');
      if (!current) return;
      hpCheckoutAllowOnce = true;
      current.click();
    }).catch(function (err) {
      hpCheckoutValidationPending = false;
      log('confirmação pré-checkout falhou', err);
      return hpMutationQueue.then(function () {
        hpShowCartMessage('Não foi possível confirmar os descontos. Tente novamente.', true);
        var current = document.querySelector('cart-drawer button[name="checkout"]');
        if (current) current.disabled = true;
      });
    });
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hp-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    /* 4º re-review do Codex: com um aceite não confirmado, esta aba não escreve no carrinho até recarregar. */
    if (hpOfferUnconfirmed) {
      hpShowOfferError(btn.dataset.hpRule || 'slot', 'Não foi possível aplicar esta oferta agora. O item não foi adicionado ao carrinho.');
      hpKeepOfferUnconfirmed();
      return;
    }
    btn.disabled = true;
    var prevTxt = btn.textContent;
    if (btn.dataset.hpLoading) btn.textContent = btn.dataset.hpLoading;

    var variantId = parseInt(btn.dataset.hpAdd, 10);
    var rule = btn.dataset.hpRule || 'slot';
    var discountCode = btn.dataset.hpDiscount || '';
    var expectedCents = parseInt(btn.dataset.hpExpected || '0', 10);
    var kitShownQuantity = Number(btn.dataset.hpKitQuantity);

    hpEnqueueMutation(async function () {
      var offerError = '';
      var unconfirmed = false;
      var addState = 'antes';
      var releaseOfferLock = function () {};
      try {
        /* Clique que já estava na fila quando um aceite anterior desta aba não confirmou: nada é escrito. */
        if (hpOfferUnconfirmed) throw hpBeforeAddError('aceite anterior não confirmado nesta aba: atualizar a página');
        var offerProps = { _hp_upsell: rule };
        if (discountCode) {
          /* 7º re-review do Codex (P2): a linha de oferta nasce com o nome 'retida:' (estado 'retida:' + 'active'
             do bloco 2). O JS dos blocos 0/1 só reconhece a regra exata e não toca nessa linha; os blocos 2/3 e este
             leem o prefixo (hpOfferRule). Identidade protegida no próprio add — nenhuma escrita depois. A Jarra fica
             no nome exato, como em todas as versões: os blocos 0–3 não conhecem 'retida:carrossel:jarra' e tirariam
             o código dela (gate M4); com o Filter em 'retida:', o bloco 1 não a desfaz por prioridade. */
          if (HP_RETAINABLE_RULES.indexOf(rule) !== -1) offerProps._hp_upsell = HP_RETAINED_PREFIX + rule;
          if (!hpIsActiveOfferCode(discountCode) || expectedCents <= 0) {
            throw new Error('configuração inválida do desconto do card');
          }
          offerProps._hp_offer_code = discountCode;
          offerProps._hp_offer_price = String(expectedCents);
          offerProps._hp_offer_source = 'cart_drawer';
          offerProps._hp_offer_type = rule.replace('carrossel:', '').replace(/-/g, '_');
          if (hpSameText(discountCode, HP_FILTER_CODES.pureSteel) || hpSameText(discountCode, HP_FILTER_CODES.pureColors)) offerProps._hp_offer_type = 'filter_pure';
          if (hpSameText(discountCode, HP_FILTER_CODES.plus)) offerProps._hp_offer_type = 'filter_plus';
          offerProps._hp_offer_status = 'active';
          offerProps._hp_offer_version = '2';
          offerProps._hp_offer_at = String(Date.now());
          offerProps._hp_offer_click = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        }
        var addItems = [{ id: variantId, quantity: 1, properties: offerProps }];
        releaseOfferLock = await hpAcquireOfferLock();
        var initialCart = await hpJson(root() + 'cart.js');
        var alreadyAdded = false;

        /* Rodada 3: o carrinho recém-lido decide. Card de outra aba ou de HTML antigo que
           prometa o que a 1ª promessa já excluiu é recusado ANTES do add — nada entra e
           nada do que já estava no carrinho é desfeito. */
        var filterCard = HP_FILTER_CODE_LIST.some(function (filterCode) { return hpSameText(discountCode, filterCode); });
        if (filterCard && !hpFilterQualifies(initialCart)) {
          throw hpBeforeAddError('card do ionizador desatualizado: carrinho sem Jarra livre ou com Jarra de oferta');
        }
        /* Bloco 2: uma linha por oferta cruzada/Filter (ativa ou retida) e direção única nas
           cruzadas — card de outra aba ou de HTML antigo que fure isso é recusado antes do add. */
        if (filterCard && (hpHasRuleLine(initialCart, 'carrossel:ionizador') || hpHasRuleLine(initialCart, 'carrossel:plus'))) {
          throw hpBeforeAddError('card do ionizador desatualizado: já há ionizador do card Filter no carrinho');
        }
        if (rule === 'carrossel:cross-plus' &&
          (hpHasRuleLine(initialCart, rule) || hpCrossQualifierQuantity(initialCart, HP_PRODUCT_PURE, 'carrossel:cross-pure') < 1)) {
          throw hpBeforeAddError('card do Plus cruzado desatualizado');
        }
        if (rule === 'carrossel:cross-pure' &&
          (hpHasRuleLine(initialCart, rule) || hpCrossQualifierQuantity(initialCart, HP_PRODUCT_PLUS, 'carrossel:cross-plus') < 1)) {
          throw hpBeforeAddError('card do Pure cruzado desatualizado');
        }
        /* Bloco 3 (review do Codex, P2): a oferta da Squeeze/Garrafa vale para 1 unidade por carrinho. Card de
           outra aba ou de HTML antigo com a oferta já no carrinho (ativa, retida ou em qtd:) prometeria um preço
           que o código, já usado, não dá mais — recusado antes do add. */
        if (HP_QTY_RULES.indexOf(rule) !== -1 && hpHasRuleLine(initialCart, rule)) {
          throw hpBeforeAddError('card desatualizado: a oferta já está no carrinho');
        }
        if (rule === 'carrossel:jarra') {
          if (hpProductQuantity(initialCart, HP_PRODUCT_PURE) < 1 && hpProductQuantity(initialCart, HP_PRODUCT_PLUS) < 1) {
            throw hpBeforeAddError('a oferta da Jarra exige um ionizador');
          }
          if (hpHasPromisedFilterIonizer(initialCart)) {
            throw hpBeforeAddError('card da Jarra desatualizado: ionizador do card Filter no carrinho');
          }
          alreadyAdded = !!hpFindOfferItem(initialCart, null, rule);
          if (alreadyAdded) addItems = [];
        }

        /* +1 (13/10): add incremental com a identidade da linha existente. A Shopify une a unidade à
           linha; não gravar quantidade absoluta, criar identidade slot: nem reconstruir o kit. Uma ação
           concorrente confirmada antes do add permanece: o card acrescenta somente sua unidade. */
        var kitProduct = rule === 'slot:plus1-pure' ? HP_PRODUCT_PURE : rule === 'slot:plus1-plus' ? HP_PRODUCT_PLUS : 0;
        if (kitProduct) {
          var kitLines = (initialCart.items || []).filter(function (item) { return item.product_id === kitProduct; });
          /* CTA antigo (inclusive sem quantidade no markup): repintar antes de aceitar outro clique.
             Não protege contra escrita externa que acontece depois desta leitura. */
          var kitQuantity = kitLines.reduce(function (total, item) { return total + item.quantity; }, 0);
          if (!(kitShownQuantity > 0) || kitShownQuantity !== kitQuantity) throw hpBeforeAddError('quantidade do CTA desatualizada: atualizar o carrinho antes do +1');
          /* Origens distintas mantêm faixas próprias no Rapi; o CTA não pode prometer uma faixa global.
             Comparar só as referências já reutilizadas pelo +1, sem reconstruir ou remarcar linhas. */
          var kitOriginKeys = ['__rapi_offer', '_rapi_bundles', '_rapi_market'];
          var kitOrigin = kitLines[0] ? (kitLines[0].properties || {}) : {};
          var mixedKitOrigins = kitLines.some(function (item) {
            var properties = item.properties || {};
            return kitOriginKeys.some(function (key) { return (properties[key] || '') !== (kitOrigin[key] || ''); });
          });
          if (mixedKitOrigins) throw hpBeforeAddError('o +1 exige uma única origem de kit: use os controles de quantidade do carrinho');
          var sameVariant = kitLines.filter(function (item) { return item.variant_id === variantId; });
          if (!kitLines.length || sameVariant.length > 1) throw hpBeforeAddError('o produto do +1 mudou ou a variante está em mais de uma linha: atualizar o carrinho');
          var kitLine = sameVariant[0];
          var kitProps = kitLine ? (kitLine.properties || {}) : {};
          if (!kitLine) {
            /* Cor nova (dono, 13/10): só referências Rapi da linha-base. Não copiar quantidade, dados
               personalizados ou promessa HP de outra variante; apenas uma unidade, sem reconstrução. */
            var sourceProps = kitLines[0].properties || {};
            ['__rapi_offer', '_rapi_bundles', '_rapi_market'].forEach(function (key) {
              if (sourceProps[key] != null) kitProps[key] = sourceProps[key];
            });
          }
          addItems = [{ id: variantId, quantity: 1, properties: kitProps }];
          if (kitLine && kitLine.selling_plan_allocation) addItems[0].selling_plan = kitLine.selling_plan_allocation.selling_plan.id;
        }
        if (!alreadyAdded) {
          log('add', addItems);
          addState = 'enviado';
          try {
            await hpJson(root() + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: addItems })
            }, !!kitProduct);
            addState = 'ok';
          } catch (errAdd) {
            addState = errAdd && errAdd.hpServerRefused ? 'recusado' : 'incerto';
            throw errAdd;
          }
          hpMarkCartMutation(1700);
        }

        if (discountCode) {
          await hpApplyAndVerifyOffer(discountCode, expectedCents, variantId, rule, alreadyAdded ? '' : offerProps._hp_offer_click);
        }
      } catch (err) {
        log('erro', err);
        if (err && err.hpBeforeAdd) {
          offerError = 'Não foi possível aplicar esta oferta agora. O item não foi adicionado ao carrinho.';
        } else if (kitProduct && addState === 'recusado') {
          offerError = 'Não foi possível aplicar esta oferta agora. O item não foi adicionado ao carrinho.';
        } else if (discountCode) {
          /* 3º re-review do Codex (P2): nenhuma escrita em linha (ver hpClickLineInCart). A Jarra que já estava no
             carrinho (alreadyAdded) é anterior ao clique e fica; sem add enviado, nada do clique entrou. */
          unconfirmed = !!alreadyAdded || addState === 'incerto';
          if (!unconfirmed && addState !== 'antes') {
            try {
              unconfirmed = await hpClickLineInCart(variantId, rule, offerProps._hp_offer_click);
            } catch (errRead) {
              unconfirmed = true;
              log('leitura do carrinho depois da falha do aceite falhou', errRead);
            }
          }
          if (unconfirmed) hpOfferUnconfirmed = true;
          offerError = unconfirmed ? HP_OFFER_UNCONFIRMED_MSG : 'Não foi possível aplicar esta oferta agora. O item não foi adicionado ao carrinho.';
        }
        btn.disabled = false;
        btn.textContent = prevTxt;
      } finally {
        releaseOfferLock();
      }

      /* re-render SEMPRE, desacoplado das mutações (Section Rendering API):
         mesmo com falha parcial o drawer reflete o carrinho real — nunca exige F5.
         O cart.js entra junto: o item_count real alimenta o guard semântico do
         swapSections (uma section stale de carrinho vazio nunca mais é pintada). */
      try {
        var paintGeneration = ++hpPaintGeneration;
        var pair = await Promise.all([
          hpJson(root() + '?sections=cart-drawer,cart-icon-bubble'),
          hpJson(root() + 'cart.js')
        ]);
        var finalCart = pair[1];
        hpIgnoreDrawerMutations(900);
        if (paintGeneration === hpPaintGeneration) {
          swapSections({ sections: pair[0], itemCount: finalCart.item_count, cart: finalCart });
        }
        if (unconfirmed) hpKeepOfferUnconfirmed();
        else if (offerError) hpShowOfferError(rule, offerError);
        if (window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          /* source 'cart-items' = semântica do tema para "o re-render já foi feito
             por quem publicou": CartItems ignora (evita o SEGUNDO re-render
             concorrente do onCartUpdate — suspeito do drawer branco de 14/07),
             mas quantity rules / price-per-item da PDP continuam atualizando */
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: finalCart });
          log('ok', finalCart.item_count);
        }
      } catch (errRender) {
        log('re-render falhou', errRender);
      }
      /* Se o swap não substituiu o botão, ele precisa voltar a ser interativo.
         Em sucesso normal o nó antigo já saiu do DOM. */
      if (btn.isConnected) {
        btn.disabled = false;
        btn.textContent = prevTxt;
      }
      hpKeepOfferUnconfirmed();  // também quando o re-render acima falhou
      hpScheduleOfferSettle('custom-settled', 2300);
    }).catch(function (err) {
      /* R1 (09/10): a fila pode recusar a tarefa antes de ela começar (reconciliação
         acima de 4 s). Nada foi adicionado: só devolver o botão e avisar. Não mexe no
         checkout nem chama rollback. */
      log('aceite não entrou na fila', err);
      if (btn.isConnected) {
        btn.disabled = false;
        btn.textContent = prevTxt;
      }
      hpShowOfferError(rule, 'Não foi possível aplicar esta oferta agora. O item não foi adicionado ao carrinho.');
    });
  });

  /* Cupom do cliente: fica fora da lista de códigos internos das ofertas.
     Ao aplicar outro cupom, substitui apenas os códigos externos e preserva
     todas as ofertas válidas. Se a combinação quebrar um preço prometido, a
     alteração é revertida antes de liberar o checkout. */
  function hpRenderCoupon(cart, message, isError) {
    var wrap = document.querySelector('[data-hp-coupon]');
    if (!wrap || !cart) return;
    var list = wrap.querySelector('[data-hp-coupon-codes]');
    var status = wrap.querySelector('[data-hp-coupon-message]');
    var submit = wrap.querySelector('[data-hp-coupon-submit]');
    var customer = hpCustomerCodes(cart);
    var details = wrap.closest('[data-hp-coupon-details]');
    var summary = details && details.querySelector('[data-hp-coupon-summary]');
    if (list) {
      list.textContent = '';
      for (var i = 0; i < customer.length; i++) {
        var state = hpCartCodeState(cart, customer[i]);
        var chip = document.createElement('span');
        chip.className = 'hp-coupon__chip' + (state && state.applicable === false ? ' hp-coupon__chip--invalid' : '');
        var label = document.createElement('span');
        label.textContent = customer[i];
        chip.appendChild(label);
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'hp-coupon__remove';
        remove.setAttribute('data-hp-coupon-remove', customer[i]);
        remove.setAttribute('aria-label', 'Remover cupom ' + customer[i]);
        remove.textContent = '×';
        chip.appendChild(remove);
        list.appendChild(chip);
      }
      list.hidden = customer.length === 0;
    }
    if (submit) submit.textContent = customer.length ? 'Alterar' : 'Aplicar';
    if (summary) summary.textContent = customer.length ? 'Cupom aplicado: ' + customer[0] : 'Tem cupom de desconto?';
    if (details && message) details.open = true;
    if (status) {
      status.textContent = message || '';
      status.hidden = !message;
      status.classList.toggle('hp-coupon__message--error', !!isError);
    }
  }

  function hpCouponCodeStateValid(cart, code) {
    var state = hpCartCodeState(cart, code);
    return !!state && state.applicable !== false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-hp-coupon-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[data-hp-coupon-input]');
    var submit = form.querySelector('[data-hp-coupon-submit]');
    var code = input ? input.value.trim() : '';
    if (!code) {
      hpJson(root() + 'cart.js').then(function (cart) {
        hpRenderCoupon(cart, 'Digite um cupom para aplicar.', true);
      });
      return;
    }
    if (code.length > 80 || code.indexOf(',') !== -1) {
      hpJson(root() + 'cart.js').then(function (cart) {
        hpRenderCoupon(cart, 'Confira o código digitado e tente novamente.', true);
      });
      return;
    }
    if (submit) submit.disabled = true;
    hpEnqueueMutation(async function () {
      var message = '';
      var isError = false;
      var cart = null;
      try {
        var before = await hpJson(root() + 'cart.js');
        var managed = hpDesiredManagedCodes(before);
        var previousCustomer = hpDesiredCustomerCodes(before);
        hpSetCustomerCodeIntent(before, [code]);
        cart = await hpSetCartCodes(before, managed, hpDesiredCustomerCodes(before));
        hpMarkCartMutation(650);
        cart = await hpReadStableCart('cupom-aplicado', 4);
        if (!hpCouponCodeStateValid(cart, code)) {
          throw new Error('cupom inexistente ou não aplicável');
        }
        if (!hpOffersKept(before, cart)) {
          throw new Error('cupom incompatível com uma oferta do carrinho');
        }
        message = 'Cupom aplicado.';
        if (input) input.value = '';
      } catch (err) {
        isError = true;
        message = err && /incompatível/.test(err.message)
          ? 'Este cupom não pode ser combinado com as ofertas do carrinho.'
          : 'Cupom inválido ou não aplicável a este pedido.';
        try {
          var restoreBase = cart || await hpJson(root() + 'cart.js');
          var restoreManaged = hpDesiredManagedCodes(restoreBase);
          var oldCustomer = typeof previousCustomer !== 'undefined' ? previousCustomer : hpCustomerCodes(restoreBase);
          hpSetCustomerCodeIntent(restoreBase, oldCustomer);
          cart = await hpSetCartCodes(restoreBase, restoreManaged, hpDesiredCustomerCodes(restoreBase));
          await hpSleep(200);
          cart = await hpJson(root() + 'cart.js');
        } catch (restoreErr) {
          message = 'Não foi possível confirmar o cupom. Atualize a página antes de finalizar.';
          var checkout = document.querySelector('cart-drawer button[name="checkout"]');
          if (checkout) checkout.disabled = true;
          log('rollback do cupom falhou', restoreErr);
        }
      }
      var refreshed = await hpRefreshDrawer('cupom');
      hpRenderCoupon(refreshed || cart, message, isError);
      if (submit && submit.isConnected) submit.disabled = false;
    }).catch(function (err) {
      log('cupom não entrou na fila', err);
      if (submit && submit.isConnected) submit.disabled = false;
      hpJson(root() + 'cart.js').then(function (cart) {
        hpRenderCoupon(cart, 'Não foi possível aplicar o cupom agora. Tente novamente.', true);
      }).catch(function () {});
    });
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-hp-coupon-remove]');
    if (!remove) return;
    e.preventDefault();
    var code = remove.getAttribute('data-hp-coupon-remove');
    remove.disabled = true;
    hpEnqueueMutation(async function () {
      var cart = null;
      try {
        cart = await hpJson(root() + 'cart.js');
        var customer = hpDesiredCustomerCodes(cart).filter(function (candidate) { return !hpSameText(candidate, code); });
        hpSetCustomerCodeIntent(cart, customer);
        cart = await hpSetCartCodes(cart, hpDesiredManagedCodes(cart), hpDesiredCustomerCodes(cart));
        hpMarkCartMutation(650);
        cart = await hpReadStableCart('cupom-removido', 4);
        if (hpCartCodeState(cart, code)) {
          cart = await hpSetCartCodes(cart, hpDesiredManagedCodes(cart), hpDesiredCustomerCodes(cart));
          hpMarkCartMutation(650);
          cart = await hpReadStableCart('cupom-removido:segunda-confirmacao', 4);
        }
        if (hpCartCodeState(cart, code)) throw new Error('cupom removido reapareceu durante a confirmação');
        var refreshed = await hpRefreshDrawer('cupom-removido');
        hpRenderCoupon(refreshed || cart, 'Cupom removido.', false);
        hpScheduleOfferSettle('cupom-removido-tardio', 3200);
      } catch (err) {
        log('remoção do cupom falhou', err);
        try {
          cart = await hpJson(root() + 'cart.js');
          hpSetCustomerCodeIntent(cart, hpCustomerCodes(cart));
          hpRenderCoupon(cart, 'Não foi possível remover o cupom agora. Tente novamente.', true);
        } catch (readErr) {
          hpShowCartMessage('Não foi possível confirmar o cupom. Atualize a página antes de finalizar.', true);
        }
        if (remove.isConnected) remove.disabled = false;
      }
    }).catch(function (err) {
      log('remoção do cupom não entrou na fila', err);
      if (remove.isConnected) remove.disabled = false;
      hpJson(root() + 'cart.js').then(function (cart) {
        hpRenderCoupon(cart, 'Não foi possível remover o cupom agora. Tente novamente.', true);
      }).catch(function () {});
    });
  });

  function hpInitCoupon() {
    hpJson(root() + 'cart.js').then(function (cart) { hpRenderCoupon(cart); }).catch(function (err) {
      log('leitura inicial do cupom falhou', err);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hpInitCoupon, { once: true });
  } else {
    hpInitCoupon();
  }

  /* seletor de cor dos cards multi-variante: troca textos e variant-alvo do botão.
     Preços vêm 100% pré-computados do Liquid ([data-hp-vjson]) — nada calculado aqui. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-hp-swatch]');
    if (!sw || sw.disabled) return;
    var card = sw.closest('[data-hp-vcard]');
    if (!card) return;
    var jsonEl = card.querySelector('[data-hp-vjson]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var vid = parseInt(sw.getAttribute('data-hp-swatch'), 10);
    var v = null;
    for (var i = 0; i < data.length; i++) { if (data[i].id === vid) v = data[i]; }
    if (!v) return;
    var all = card.querySelectorAll('[data-hp-swatch]');
    for (var j = 0; j < all.length; j++) {
      var on = all[j] === sw;
      all[j].classList.toggle('hp-swatch--on', on);
      all[j].setAttribute('aria-checked', on ? 'true' : 'false');
    }
    function setTxt(sel, txt) {
      var n = card.querySelector(sel);
      if (n && txt) n.textContent = txt;
    }
    setTxt('[data-hp-t-title]', v.title);
    setTxt('[data-hp-t-was]', v.was);
    setTxt('[data-hp-t-save]', v.save);
    setTxt('[data-hp-t-cor]', v.cor);
    var btn = card.querySelector('[data-hp-add]');
    if (btn) {
      btn.setAttribute('data-hp-add', String(v.id));
      if (v.discount) btn.setAttribute('data-hp-discount', v.discount);
      else btn.removeAttribute('data-hp-discount');
      if (v.expected) btn.setAttribute('data-hp-expected', String(v.expected));
      else btn.removeAttribute('data-hp-expected');
      if (v.cta) btn.textContent = v.cta;
    }
    log('swatch', v.cor, v.id);
  });

  /* teaser "role para ver as ofertas": visível só quando o carrossel existe e está fora da dobra */
  var hpScrolling = false;
  var hpIO = null, hpObserved = null;
  function hpActionableOffers() {
    var offers = document.querySelector('.hp-offers');
    return offers && offers.querySelector('[data-hp-add]:not([disabled])') ? offers : null;
  }
  /* IntersectionObserver = fonte contínua da verdade: re-decide o teaser a cada mudança
     real de visibilidade (scroll, resize, imagens carregando, reduced-motion sem transição) */
  function hpEnsureObserver() {
    if (!('IntersectionObserver' in window)) return;
    var offers = hpActionableOffers();
    if (!offers) {
      if (hpIO) hpIO.disconnect();
      hpObserved = null;
      return;
    }
    if (hpObserved === offers) return;
    if (hpIO) hpIO.disconnect();
    hpObserved = offers;
    hpIO = new IntersectionObserver(function (entries) {
      if (hpScrolling) return;
      var t = document.querySelector('[data-hp-teaser]');
      var off = hpActionableOffers();
      if (!t || !off) return;
      var sp = off.closest('cart-drawer-items') || off.parentElement;
      var remaining = sp.scrollHeight - sp.clientHeight - sp.scrollTop;
      t.hidden = entries[entries.length - 1].isIntersecting || remaining < 120;
    }, { threshold: 0.05 });
    hpIO.observe(offers);
  }
  function hpTeaserCheck() {
    if (hpScrolling) return; /* não reexibir durante o scroll programático (cancelaria o smooth) */
    hpEnsureObserver();
    var teaser = document.querySelector('[data-hp-teaser]');
    if (!teaser) return;
    var offers = hpActionableOffers();
    if (!offers) { teaser.hidden = true; return; }
    var scroller = offers.closest('cart-drawer-items') || offers.parentElement;
    var so = scroller.getBoundingClientRect();
    var oo = offers.getBoundingClientRect();
    /* limite visível real = o menor entre o fim do container e a viewport —
       no layout mobile o container reporta rects maiores que a tela */
    var limit = Math.min(so.bottom, window.innerHeight || so.bottom);
    var visible = oo.top < limit - 40; /* topo do carrossel entrou na área visível */
    /* só oferecer o atalho quando há rolagem SIGNIFICATIVA a fazer — com carrinho
       pequeno o carrossel já dá o "peek" e um toque que mal rola parece quebrado */
    var remaining = scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop;
    teaser.hidden = visible || remaining < 120;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hp-teaser]');
    if (!t) return;
    var offers = hpActionableOffers();
    if (!offers) return;
    t.hidden = true;
    hpScrolling = true;
    var sp = offers.closest('cart-drawer-items') || offers.parentElement;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var to = offers.getBoundingClientRect().top - sp.getBoundingClientRect().top + sp.scrollTop - 8;
    var max = sp.scrollHeight - sp.clientHeight;
    if (to > max) to = max;
    /* animação própria via rAF: o scrollTo smooth nativo é cancelado por reflows do drawer */
    var from = sp.scrollTop, dur = reduced ? 0 : 450, t0 = null, done = false;
    function hpFinish() {
      if (done) return;
      done = true;
      sp.scrollTop = to;
      hpScrolling = false;
      hpTeaserCheck();
    }
    function hpStep(now) {
      if (done) return;
      if (t0 === null) t0 = now;
      var k = dur === 0 ? 1 : Math.min(1, (now - t0) / dur);
      k = 1 - Math.pow(1 - k, 3);
      sp.scrollTop = from + (to - from) * k;
      if (k < 1) requestAnimationFrame(hpStep);
      else hpFinish();
    }
    requestAnimationFrame(hpStep);
    setTimeout(hpFinish, dur + 250); /* garantia: rAF pode ser suspenso (aba em background) */
  });
  document.addEventListener('click', function () { setTimeout(hpTeaserCheck, 400); });
  document.addEventListener('scroll', function () { hpTeaserCheck(); }, true);
  /* o drawer abre com transição — rects só são confiáveis depois dela */
  document.addEventListener('transitionend', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-drawer')) hpTeaserCheck();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hpTeaserCheck);
  else hpTeaserCheck();

  /* dots do carrossel — listener de scroll com capture (sobrevive a re-render);
     escopo por grupo (.hp-group) desde os carrosséis por classe de 14/07 */
  document.addEventListener('scroll', function (e) {
    var rail = e.target;
    if (!rail || !rail.classList || !rail.classList.contains('hp-rail')) return;
    var wrap = rail.closest('.hp-group') || rail.closest('.hp-offers');
    if (!wrap) return;
    var dots = wrap.querySelectorAll('.hp-dots i');
    if (!dots.length) return;
    var per = rail.scrollWidth / dots.length;
    var i = Math.min(dots.length - 1, Math.round(rail.scrollLeft / per));
    dots.forEach(function (d, k) { d.classList.toggle('hp-on', k === i); });
  }, true);
})();
